<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>嘉兴侧钢箱梁</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img">
          <div class="tower-name tower-name-z3">Z3</div>
          <div class="tower-name tower-name-z4">Z4</div>
          <div class="tower-name tower-name-z5">Z5</div>

          <el-tooltip class="station-block station-block-g1g2" content="Z3B5钢箱梁G1/G2除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station19"></router-link>
          </el-tooltip>
          <div class="stati sta-g1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z3B5-L钢箱梁G1除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ3B5LSteelBoxG1, currentBDehumidifierZ3B5LSteelBoxG1,
                      currentCDehumidifierZ3B5LSteelBoxG1],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ3B5LSteelBoxG1, voltageBCDehumidifierZ3B5LSteelBoxG1,
                      voltageACDehumidifierZ3B5LSteelBoxG1],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ3B5LSteelBoxG1, powerReactiveDehumidifierZ3B5LSteelBoxG1,
                      powerApparentDehumidifierZ3B5LSteelBoxG1],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ3B5LSteelBoxG1, energyReactiveDehumidifierZ3B5LSteelBoxG1],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ3B5LSteelBoxG1, "Hz") }}
              </div>
              <div :class="errorZ3B5LSteelBoxG1" class="state-info right-pos" @dblclick="hrefToScenario('5396fee0-6842-4712-a68d-3504261c0189')"
                v-loading="stationNameLoadingDict['stationG1']">
                <p>
                  <span class="bold">Z3B5-L钢箱梁G1</span>
                  <span :class="runningClassZ3B5LSteelBoxG1" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ3B5LSteelBoxG1 | toFixed }}A {{ currentBDehumidifierZ3B5LSteelBoxG1 |
                    toFixed }}A
                    {{ currentCDehumidifierZ3B5LSteelBoxG1 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ3B5LSteelBoxG1 | toFixed }}V {{ voltageBCDehumidifierZ3B5LSteelBoxG1 |
                    toFixed }}V
                    {{ voltageACDehumidifierZ3B5LSteelBoxG1 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ3B5LSteelBoxG1 | toFixed }}kW {{
                    powerReactiveDehumidifierZ3B5LSteelBoxG1 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ3B5LSteelBoxG1 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ3B5LSteelBoxG1 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ3B5LSteelBoxG1 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ3B5LSteelBoxG1 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z3B5-R钢箱梁G2除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ3B5RSteelBoxG2, currentBDehumidifierZ3B5RSteelBoxG2,
                      currentCDehumidifierZ3B5RSteelBoxG2],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ3B5RSteelBoxG2, voltageBCDehumidifierZ3B5RSteelBoxG2,
                      voltageACDehumidifierZ3B5RSteelBoxG2],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ3B5RSteelBoxG2, powerReactiveDehumidifierZ3B5RSteelBoxG2,
                      powerApparentDehumidifierZ3B5RSteelBoxG2],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ3B5RSteelBoxG2, energyReactiveDehumidifierZ3B5RSteelBoxG2],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ3B5RSteelBoxG2, "Hz") }}
              </div>
              <div :class="errorZ3B5RSteelBoxG2" class="state-info right-pos" @dblclick="hrefToScenario('f2766f78-e229-4675-b3a8-75026d5641c8')"
                v-loading="stationNameLoadingDict['stationG2']">
                <p>
                  <span class="bold">Z3B5-R钢箱梁G2</span>
                  <span :class="runningClassZ3B5RSteelBoxG2" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ3B5RSteelBoxG2 | toFixed }}A {{ currentBDehumidifierZ3B5RSteelBoxG2 |
                    toFixed }}A
                    {{ currentCDehumidifierZ3B5RSteelBoxG2 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ3B5RSteelBoxG2 | toFixed }}V {{ voltageBCDehumidifierZ3B5RSteelBoxG2 |
                    toFixed }}V
                    {{ voltageACDehumidifierZ3B5RSteelBoxG2 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ3B5RSteelBoxG2 | toFixed }}kW {{
                    powerReactiveDehumidifierZ3B5RSteelBoxG2 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ3B5RSteelBoxG2 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ3B5RSteelBoxG2 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ3B5RSteelBoxG2 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ3B5RSteelBoxG2 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g3g4" content="Z4B11钢箱梁G3/G4除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station20"></router-link>
          </el-tooltip>
          <div class="stati sta-g3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z4B11-L钢箱梁G3除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ4B11LSteelBoxG3, currentBDehumidifierZ4B11LSteelBoxG3,
                      currentCDehumidifierZ4B11LSteelBoxG3],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ4B11LSteelBoxG3, voltageBCDehumidifierZ4B11LSteelBoxG3,
                      voltageACDehumidifierZ4B11LSteelBoxG3],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ4B11LSteelBoxG3, powerReactiveDehumidifierZ4B11LSteelBoxG3,
                      powerApparentDehumidifierZ4B11LSteelBoxG3],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ4B11LSteelBoxG3, energyReactiveDehumidifierZ4B11LSteelBoxG3],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ4B11LSteelBoxG3, "Hz") }}
              </div>
              <div :class="errorZ4B11LSteelBoxG3" class="state-info bottom-pos" @dblclick="hrefToScenario('eb9059d0-6fed-4146-bd38-b76e8b1f142f')"
                v-loading="stationNameLoadingDict['stationG3']">
                <p>
                  <span class="bold">Z4B11-L钢箱梁G3</span>
                  <span :class="runningClassZ4B11LSteelBoxG3" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ4B11LSteelBoxG3 | toFixed }}A {{ currentBDehumidifierZ4B11LSteelBoxG3 |
                    toFixed }}A
                    {{ currentCDehumidifierZ4B11LSteelBoxG3 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ4B11LSteelBoxG3 | toFixed }}V {{ voltageBCDehumidifierZ4B11LSteelBoxG3
                    | toFixed }}V
                    {{ voltageACDehumidifierZ4B11LSteelBoxG3 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ4B11LSteelBoxG3 | toFixed }}kW {{
                    powerReactiveDehumidifierZ4B11LSteelBoxG3 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ4B11LSteelBoxG3 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ4B11LSteelBoxG3 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ4B11LSteelBoxG3 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ4B11LSteelBoxG3 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z4B11-R钢箱梁G4除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ4B11RSteelBoxG4, currentBDehumidifierZ4B11RSteelBoxG4,
                      currentCDehumidifierZ4B11RSteelBoxG4],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ4B11RSteelBoxG4, voltageBCDehumidifierZ4B11RSteelBoxG4,
                      voltageACDehumidifierZ4B11RSteelBoxG4],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ4B11RSteelBoxG4, powerReactiveDehumidifierZ4B11RSteelBoxG4,
                      powerApparentDehumidifierZ4B11RSteelBoxG4],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ4B11RSteelBoxG4, energyReactiveDehumidifierZ4B11RSteelBoxG4],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ4B11RSteelBoxG4, "Hz") }}
              </div>
              <div :class="errorZ4B11RSteelBoxG4" class="state-info top-pos" @dblclick="hrefToScenario('b5034eeb-30be-4979-939e-53e3fa160a7c')"
                v-loading="stationNameLoadingDict['stationG4']">
                <p>
                  <span class="bold">Z4B11-R钢箱梁G4</span>
                  <span :class="runningClassZ4B11RSteelBoxG4" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ4B11RSteelBoxG4 | toFixed }}A {{ currentBDehumidifierZ4B11RSteelBoxG4 |
                    toFixed }}A
                    {{ currentCDehumidifierZ4B11RSteelBoxG4 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ4B11RSteelBoxG4 | toFixed }}V {{ voltageBCDehumidifierZ4B11RSteelBoxG4
                    | toFixed }}V
                    {{ voltageACDehumidifierZ4B11RSteelBoxG4 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ4B11RSteelBoxG4 | toFixed }}kW {{
                    powerReactiveDehumidifierZ4B11RSteelBoxG4 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ4B11RSteelBoxG4 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ4B11RSteelBoxG4 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ4B11RSteelBoxG4 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ4B11RSteelBoxG4 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g5g6" content="Z4Z8钢箱梁G5/G6除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station21"></router-link>
          </el-tooltip>
          <div class="stati sta-g6">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z4Z8-L钢箱梁G6除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ4Z8LSteelBoxG6, currentBDehumidifierZ4Z8LSteelBoxG6,
                      currentCDehumidifierZ4Z8LSteelBoxG6],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ4Z8LSteelBoxG6, voltageBCDehumidifierZ4Z8LSteelBoxG6,
                      voltageACDehumidifierZ4Z8LSteelBoxG6],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ4Z8LSteelBoxG6, powerReactiveDehumidifierZ4Z8LSteelBoxG6,
                      powerApparentDehumidifierZ4Z8LSteelBoxG6],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ4Z8LSteelBoxG6, energyReactiveDehumidifierZ4Z8LSteelBoxG6],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ4Z8LSteelBoxG6, "Hz") }}
              </div>
              <div :class="errorZ4Z8LSteelBoxG6" class="state-info top-pos" @dblclick="hrefToScenario('6f6ed5be-7474-403d-aa47-22fbb4e3af67')"
                v-loading="stationNameLoadingDict['stationG6']">
                <p>
                  <span class="bold">Z4Z8-L钢箱梁G6</span>
                  <span :class="runningClassZ4Z8LSteelBoxG6" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ4Z8LSteelBoxG6 | toFixed }}A {{ currentBDehumidifierZ4Z8LSteelBoxG6 |
                    toFixed }}A
                    {{ currentCDehumidifierZ4Z8LSteelBoxG6 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ4Z8LSteelBoxG6 | toFixed }}V {{ voltageBCDehumidifierZ4Z8LSteelBoxG6 |
                    toFixed }}V
                    {{ voltageACDehumidifierZ4Z8LSteelBoxG6 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ4Z8LSteelBoxG6 | toFixed }}kW {{
                    powerReactiveDehumidifierZ4Z8LSteelBoxG6 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ4Z8LSteelBoxG6 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ4Z8LSteelBoxG6 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ4Z8LSteelBoxG6 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ4Z8LSteelBoxG6 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z4Z8-R钢箱梁G5除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ4Z8RSteelBoxG5, currentBDehumidifierZ4Z8RSteelBoxG5,
                      currentCDehumidifierZ4Z8RSteelBoxG5],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ4Z8RSteelBoxG5, voltageBCDehumidifierZ4Z8RSteelBoxG5,
                      voltageACDehumidifierZ4Z8RSteelBoxG5],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ4Z8RSteelBoxG5, powerReactiveDehumidifierZ4Z8RSteelBoxG5,
                      powerApparentDehumidifierZ4Z8RSteelBoxG5],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ4Z8RSteelBoxG5, energyReactiveDehumidifierZ4Z8RSteelBoxG5],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ4Z8RSteelBoxG5, "Hz") }}
              </div>
              <div :class="errorZ4Z8RSteelBoxG5" class="state-info bottom-pos" @dblclick="hrefToScenario('6b1964e2-88d1-4418-897a-06469fb4d46f')"
                v-loading="stationNameLoadingDict['stationG5']">
                <p>
                  <span class="bold">Z4Z8-R钢箱梁G5</span>
                  <span :class="runningClassZ4Z8RSteelBoxG5" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ4Z8RSteelBoxG5 | toFixed }}A {{ currentBDehumidifierZ4Z8RSteelBoxG5 |
                    toFixed }}A
                    {{ currentCDehumidifierZ4Z8RSteelBoxG5 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ4Z8RSteelBoxG5 | toFixed }}V {{ voltageBCDehumidifierZ4Z8RSteelBoxG5 |
                    toFixed }}V
                    {{ voltageACDehumidifierZ4Z8RSteelBoxG5 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ4Z8RSteelBoxG5 | toFixed }}kW {{
                    powerReactiveDehumidifierZ4Z8RSteelBoxG5 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ4Z8RSteelBoxG5 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ4Z8RSteelBoxG5 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ4Z8RSteelBoxG5 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ4Z8RSteelBoxG5 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g7g8" content="Z5Z1钢箱梁G7/G8除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station15"></router-link>
          </el-tooltip>
          <div class="stati sta-g8">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z5Z1-L钢箱梁G8除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ5Z1LSteelBoxG8, currentBDehumidifierZ5Z1LSteelBoxG8,
                      currentCDehumidifierZ5Z1LSteelBoxG8],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ5Z1LSteelBoxG8, voltageBCDehumidifierZ5Z1LSteelBoxG8,
                      voltageACDehumidifierZ5Z1LSteelBoxG8],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ5Z1LSteelBoxG8, powerReactiveDehumidifierZ5Z1LSteelBoxG8,
                      powerApparentDehumidifierZ5Z1LSteelBoxG8],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ5Z1LSteelBoxG8, energyReactiveDehumidifierZ5Z1LSteelBoxG8],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ5Z1LSteelBoxG8, "Hz") }}
              </div>
              <div :class="errorZ5Z1LSteelBoxG8" class="state-info left-pos" @dblclick="hrefToScenario('f42739a3-edbf-43b8-b72d-1a21c2d80076')"
                v-loading="stationNameLoadingDict['stationG8']">
                <p>
                  <span class="bold">Z5Z1-L钢箱梁G8</span>
                  <span :class="runningClassZ5Z1LSteelBoxG8" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ5Z1LSteelBoxG8 | toFixed }}A {{ currentBDehumidifierZ5Z1LSteelBoxG8 |
                    toFixed }}A
                    {{ currentCDehumidifierZ5Z1LSteelBoxG8 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ5Z1LSteelBoxG8 | toFixed }}V {{ voltageBCDehumidifierZ5Z1LSteelBoxG8 |
                    toFixed }}V
                    {{ voltageACDehumidifierZ5Z1LSteelBoxG8 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ5Z1LSteelBoxG8 | toFixed }}kW {{
                    powerReactiveDehumidifierZ5Z1LSteelBoxG8 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ5Z1LSteelBoxG8 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ5Z1LSteelBoxG8 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ5Z1LSteelBoxG8 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ5Z1LSteelBoxG8 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g7">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z5Z1-R钢箱梁G7除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ5Z1RSteelBoxG7, currentBDehumidifierZ5Z1RSteelBoxG7,
                      currentCDehumidifierZ5Z1RSteelBoxG7],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ5Z1RSteelBoxG7, voltageBCDehumidifierZ5Z1RSteelBoxG7,
                      voltageACDehumidifierZ5Z1RSteelBoxG7],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ5Z1RSteelBoxG7, powerReactiveDehumidifierZ5Z1RSteelBoxG7,
                      powerApparentDehumidifierZ5Z1RSteelBoxG7],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ5Z1RSteelBoxG7, energyReactiveDehumidifierZ5Z1RSteelBoxG7],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ5Z1RSteelBoxG7, "Hz") }}
              </div>
              <div :class="errorZ5Z1RSteelBoxG7" class="state-info left-pos" @dblclick="hrefToScenario('7fe9d757-21e9-4827-b80a-f5f896b23384')"
                v-loading="stationNameLoadingDict['stationG7']">
                <p>
                  <span class="bold">Z5Z1-R钢箱梁G7</span>
                  <span :class="runningClassZ5Z1RSteelBoxG7" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ5Z1RSteelBoxG7 | toFixed }}A {{ currentBDehumidifierZ5Z1RSteelBoxG7 |
                    toFixed }}A
                    {{ currentCDehumidifierZ5Z1RSteelBoxG7 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ5Z1RSteelBoxG7 | toFixed }}V {{ voltageBCDehumidifierZ5Z1RSteelBoxG7 |
                    toFixed }}V
                    {{ voltageACDehumidifierZ5Z1RSteelBoxG7 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ5Z1RSteelBoxG7 | toFixed }}kW {{
                    powerReactiveDehumidifierZ5Z1RSteelBoxG7 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ5Z1RSteelBoxG7 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ5Z1RSteelBoxG7 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ5Z1RSteelBoxG7 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ5Z1RSteelBoxG7 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>绍兴侧钢箱梁</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <!-- <div class="sensor1">排气口</div>
          <div class="sensor2">进气口</div> -->
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">嘉兴</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">绍兴</span>
        </div>
        <div class="cable-img image-reversed">
          <div class="tower-name tower-name-z6">Z6</div>
          <div class="tower-name tower-name-z7">Z7</div>
          <div class="tower-name tower-name-z8">Z8</div>

          <el-tooltip class="station-block station-block-g9g10" content="Z6Z1钢箱梁G9/G10除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station31"></router-link>
          </el-tooltip>
          <div class="stati sta-g9">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z6Z1-L钢箱梁G9除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ6Z1LSteelBoxG9, currentBDehumidifierZ6Z1LSteelBoxG9,
                      currentCDehumidifierZ6Z1LSteelBoxG9],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ6Z1LSteelBoxG9, voltageBCDehumidifierZ6Z1LSteelBoxG9,
                      voltageACDehumidifierZ6Z1LSteelBoxG9],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ6Z1LSteelBoxG9, powerReactiveDehumidifierZ6Z1LSteelBoxG9,
                      powerApparentDehumidifierZ6Z1LSteelBoxG9],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ6Z1LSteelBoxG9, energyReactiveDehumidifierZ6Z1LSteelBoxG9],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ6Z1LSteelBoxG9, "Hz") }}
              </div>
              <div :class="errorZ6Z1LSteelBoxG9" class="state-info right-pos" @dblclick="hrefToScenario('8b5c9081-c5c1-4fc8-8d6d-c18eca2a65cb')"
                v-loading="stationNameLoadingDict['stationG9']">
                <p>
                  <span class="bold">Z6Z1-L钢箱梁G9</span>
                  <span :class="runningClassZ6Z1LSteelBoxG9" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ6Z1LSteelBoxG9 | toFixed }}A {{ currentBDehumidifierZ6Z1LSteelBoxG9 |
                    toFixed }}A
                    {{ currentCDehumidifierZ6Z1LSteelBoxG9 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ6Z1LSteelBoxG9 | toFixed }}V {{ voltageBCDehumidifierZ6Z1LSteelBoxG9 |
                    toFixed }}V
                    {{ voltageACDehumidifierZ6Z1LSteelBoxG9 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ6Z1LSteelBoxG9 | toFixed }}kW {{
                    powerReactiveDehumidifierZ6Z1LSteelBoxG9 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ6Z1LSteelBoxG9 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ6Z1LSteelBoxG9 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ6Z1LSteelBoxG9 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ6Z1LSteelBoxG9 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g10">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z6Z1-R钢箱梁G10除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ6Z1RSteelBoxG10, currentBDehumidifierZ6Z1RSteelBoxG10,
                      currentCDehumidifierZ6Z1RSteelBoxG10],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ6Z1RSteelBoxG10, voltageBCDehumidifierZ6Z1RSteelBoxG10,
                      voltageACDehumidifierZ6Z1RSteelBoxG10],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ6Z1RSteelBoxG10, powerReactiveDehumidifierZ6Z1RSteelBoxG10,
                      powerApparentDehumidifierZ6Z1RSteelBoxG10],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ6Z1RSteelBoxG10, energyReactiveDehumidifierZ6Z1RSteelBoxG10],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ6Z1RSteelBoxG10, "Hz") }}
              </div>
              <div :class="errorZ6Z1RSteelBoxG10" class="state-info right-pos" @dblclick="hrefToScenario('37913c69-ff69-496b-8595-42e8425142c6')"
                v-loading="stationNameLoadingDict['stationG10']">
                <p>
                  <span class="bold">Z6Z1-R钢箱梁G10</span>
                  <span :class="runningClassZ6Z1RSteelBoxG10" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ6Z1RSteelBoxG10 | toFixed }}A {{ currentBDehumidifierZ6Z1RSteelBoxG10 |
                    toFixed }}A
                    {{ currentCDehumidifierZ6Z1RSteelBoxG10 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ6Z1RSteelBoxG10 | toFixed }}V {{ voltageBCDehumidifierZ6Z1RSteelBoxG10
                    | toFixed }}V
                    {{ voltageACDehumidifierZ6Z1RSteelBoxG10 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ6Z1RSteelBoxG10 | toFixed }}kW {{
                    powerReactiveDehumidifierZ6Z1RSteelBoxG10 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ6Z1RSteelBoxG10 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ6Z1RSteelBoxG10 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ6Z1RSteelBoxG10 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ6Z1RSteelBoxG10 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g11g12" content="Z7Z8钢箱梁G11/G12除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station30"></router-link>
          </el-tooltip>
          <div class="stati sta-g11">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z7Z8-L钢箱梁G11除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ7Z8LSteelBoxG11, currentBDehumidifierZ7Z8LSteelBoxG11,
                      currentCDehumidifierZ7Z8LSteelBoxG11],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ7Z8LSteelBoxG11, voltageBCDehumidifierZ7Z8LSteelBoxG11,
                      voltageACDehumidifierZ7Z8LSteelBoxG11],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ7Z8LSteelBoxG11, powerReactiveDehumidifierZ7Z8LSteelBoxG11,
                      powerApparentDehumidifierZ7Z8LSteelBoxG11],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ7Z8LSteelBoxG11, energyReactiveDehumidifierZ7Z8LSteelBoxG11],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ7Z8LSteelBoxG11, "Hz") }}
              </div>
              <div :class="errorZ7Z8LSteelBoxG11" class="state-info bottom-pos" @dblclick="hrefToScenario('218d14eb-6c4e-450a-949a-95f7705c20f8')"
                v-loading="stationNameLoadingDict['stationG11']">
                <p>
                  <span class="bold">Z7Z8-L钢箱梁G11</span>
                  <span :class="runningClassZ7Z8LSteelBoxG11" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ7Z8LSteelBoxG11 | toFixed }}A {{ currentBDehumidifierZ7Z8LSteelBoxG11 |
                    toFixed }}A
                    {{ currentCDehumidifierZ7Z8LSteelBoxG11 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ7Z8LSteelBoxG11 | toFixed }}V {{ voltageBCDehumidifierZ7Z8LSteelBoxG11
                    | toFixed }}V
                    {{ voltageACDehumidifierZ7Z8LSteelBoxG11 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ7Z8LSteelBoxG11 | toFixed }}kW {{
                    powerReactiveDehumidifierZ7Z8LSteelBoxG11 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ7Z8LSteelBoxG11 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ7Z8LSteelBoxG11 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ7Z8LSteelBoxG11 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ7Z8LSteelBoxG11 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g12">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z7Z8-R钢箱梁G12除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ7Z8RSteelBoxG12, currentBDehumidifierZ7Z8RSteelBoxG12,
                      currentCDehumidifierZ7Z8RSteelBoxG12],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ7Z8RSteelBoxG12, voltageBCDehumidifierZ7Z8RSteelBoxG12,
                      voltageACDehumidifierZ7Z8RSteelBoxG12],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ7Z8RSteelBoxG12, powerReactiveDehumidifierZ7Z8RSteelBoxG12,
                      powerApparentDehumidifierZ7Z8RSteelBoxG12],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ7Z8RSteelBoxG12, energyReactiveDehumidifierZ7Z8RSteelBoxG12],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ7Z8RSteelBoxG12, "Hz") }}
              </div>
              <div :class="errorZ7Z8RSteelBoxG12" class="state-info top-pos" @dblclick="hrefToScenario('f16a9fba-0b3f-4c5e-9753-d2b58082fbf2')"
                v-loading="stationNameLoadingDict['stationG12']">
                <p>
                  <span class="bold">Z7Z8-R钢箱梁G12</span>
                  <span :class="runningClassZ7Z8RSteelBoxG12" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ7Z8RSteelBoxG12 | toFixed }}A {{ currentBDehumidifierZ7Z8RSteelBoxG12 |
                    toFixed }}A
                    {{ currentCDehumidifierZ7Z8RSteelBoxG12 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ7Z8RSteelBoxG12 | toFixed }}V {{ voltageBCDehumidifierZ7Z8RSteelBoxG12
                    | toFixed }}V
                    {{ voltageACDehumidifierZ7Z8RSteelBoxG12 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ7Z8RSteelBoxG12 | toFixed }}kW {{
                    powerReactiveDehumidifierZ7Z8RSteelBoxG12 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ7Z8RSteelBoxG12 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ7Z8RSteelBoxG12 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ7Z8RSteelBoxG12 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ7Z8RSteelBoxG12 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g13g14" content="Z7B11钢箱梁G13/G14除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station11"></router-link>
          </el-tooltip>
          <div class="stati sta-g14">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z7B11-L钢箱梁G14除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ7B11LSteelBoxG14, currentBDehumidifierZ7B11LSteelBoxG14,
                      currentCDehumidifierZ7B11LSteelBoxG14],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ7B11LSteelBoxG14, voltageBCDehumidifierZ7B11LSteelBoxG14,
                      voltageACDehumidifierZ7B11LSteelBoxG14],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [
                      powerActiveDehumidifierZ7B11LSteelBoxG14,
                      powerReactiveDehumidifierZ7B11LSteelBoxG14,
                      powerApparentDehumidifierZ7B11LSteelBoxG14,
                    ],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ7B11LSteelBoxG14, energyReactiveDehumidifierZ7B11LSteelBoxG14],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ7B11LSteelBoxG14, "Hz") }}
              </div>
              <div :class="errorZ7B11LSteelBoxG14" class="state-info top-pos" @dblclick="hrefToScenario('9734e754-8601-4e81-8445-54bb12640df6')"
                v-loading="stationNameLoadingDict['stationG14']">
                <p>
                  <span class="bold">Z7B11-L钢箱梁G14</span>
                  <span :class="runningClassZ7B11LSteelBoxG14" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ7B11LSteelBoxG14 | toFixed }}A {{ currentBDehumidifierZ7B11LSteelBoxG14
                    | toFixed }}A
                    {{ currentCDehumidifierZ7B11LSteelBoxG14 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ7B11LSteelBoxG14 | toFixed }}V {{
                    voltageBCDehumidifierZ7B11LSteelBoxG14 | toFixed }}V
                    {{ voltageACDehumidifierZ7B11LSteelBoxG14 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ7B11LSteelBoxG14 | toFixed }}kW {{
                    powerReactiveDehumidifierZ7B11LSteelBoxG14 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ7B11LSteelBoxG14 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ7B11LSteelBoxG14 | toFixed }}kWh
                    {{ energyReactiveDehumidifierZ7B11LSteelBoxG14 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ7B11LSteelBoxG14 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g13">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z7B11-R钢箱梁G13除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ7B11RSteelBoxG13, currentBDehumidifierZ7B11RSteelBoxG13,
                      currentCDehumidifierZ7B11RSteelBoxG13],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ7B11RSteelBoxG13, voltageBCDehumidifierZ7B11RSteelBoxG13,
                      voltageACDehumidifierZ7B11RSteelBoxG13],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [
                      powerActiveDehumidifierZ7B11RSteelBoxG13,
                      powerReactiveDehumidifierZ7B11RSteelBoxG13,
                      powerApparentDehumidifierZ7B11RSteelBoxG13,
                    ],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ7B11RSteelBoxG13, energyReactiveDehumidifierZ7B11RSteelBoxG13],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ7B11RSteelBoxG13, "Hz") }}
              </div>
              <div :class="errorZ7B11RSteelBoxG13" class="state-info bottom-pos" @dblclick="hrefToScenario('4a35b34a-95a6-43fb-b6bc-2212c9b27b27')"
                v-loading="stationNameLoadingDict['stationG13']">
                <p>
                  <span class="bold">Z7B11-R钢箱梁G13</span>
                  <span :class="runningClassZ7B11RSteelBoxG13" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ7B11RSteelBoxG13 | toFixed }}A {{ currentBDehumidifierZ7B11RSteelBoxG13
                    | toFixed }}A
                    {{ currentCDehumidifierZ7B11RSteelBoxG13 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ7B11RSteelBoxG13 | toFixed }}V {{
                    voltageBCDehumidifierZ7B11RSteelBoxG13 | toFixed }}V
                    {{ voltageACDehumidifierZ7B11RSteelBoxG13 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ7B11RSteelBoxG13 | toFixed }}kW {{
                    powerReactiveDehumidifierZ7B11RSteelBoxG13 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ7B11RSteelBoxG13 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ7B11RSteelBoxG13 | toFixed }}kWh
                    {{ energyReactiveDehumidifierZ7B11RSteelBoxG13 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ7B11RSteelBoxG13 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <el-tooltip class="station-block station-block-g15g16" content="Z8B5钢箱梁G15/G16除湿机" effect="light"
            placement="top">
            <router-link class="iconfont iconshebei" to="/jiashao/gasclampStation/station28"></router-link>
          </el-tooltip>
          <div class="stati sta-g16">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z8B5-L钢箱梁G16除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ8B5LSteelBoxG16, currentBDehumidifierZ8B5LSteelBoxG16,
                      currentCDehumidifierZ8B5LSteelBoxG16],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ8B5LSteelBoxG16, voltageBCDehumidifierZ8B5LSteelBoxG16,
                      voltageACDehumidifierZ8B5LSteelBoxG16],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ8B5LSteelBoxG16, powerReactiveDehumidifierZ8B5LSteelBoxG16,
                      powerApparentDehumidifierZ8B5LSteelBoxG16],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ8B5LSteelBoxG16, energyReactiveDehumidifierZ8B5LSteelBoxG16],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ8B5LSteelBoxG16, "Hz") }}
              </div>
              <div :class="errorZ8B5LSteelBoxG16" class="state-info left-pos" @dblclick="hrefToScenario('4359f316-e94c-4e7c-b948-9181008a50a5')"
                v-loading="stationNameLoadingDict['stationG16']">
                <p>
                  <span class="bold">Z8B5-L钢箱梁G16</span>
                  <span :class="runningClassZ8B5LSteelBoxG16" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ8B5LSteelBoxG16 | toFixed }}A {{ currentBDehumidifierZ8B5LSteelBoxG16 |
                    toFixed }}A
                    {{ currentCDehumidifierZ8B5LSteelBoxG16 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ8B5LSteelBoxG16 | toFixed }}V {{ voltageBCDehumidifierZ8B5LSteelBoxG16
                    | toFixed }}V
                    {{ voltageACDehumidifierZ8B5LSteelBoxG16 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ8B5LSteelBoxG16 | toFixed }}kW {{
                    powerReactiveDehumidifierZ8B5LSteelBoxG16 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ8B5LSteelBoxG16 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ8B5LSteelBoxG16 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ8B5LSteelBoxG16 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ8B5LSteelBoxG16 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-g15">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                Z8B5-R钢箱梁G15除湿机
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电流",
                    ["Ia", "Ib", "Ic"],
                    [currentADehumidifierZ8B5RSteelBoxG15, currentBDehumidifierZ8B5RSteelBoxG15,
                      currentCDehumidifierZ8B5RSteelBoxG15],
                    ["A", "A", "A"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电压",
                    ["ab", "bc", "ac"],
                    [voltageABDehumidifierZ8B5RSteelBoxG15, voltageBCDehumidifierZ8B5RSteelBoxG15,
                      voltageACDehumidifierZ8B5RSteelBoxG15],
                    ["V", "V", "V"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "功率",
                    ["P", "Q", "S"],
                    [powerActiveDehumidifierZ8B5RSteelBoxG15, powerReactiveDehumidifierZ8B5RSteelBoxG15,
                      powerApparentDehumidifierZ8B5RSteelBoxG15],
                    ["kW", "kvar", "kVA"]
                  )
                }}
                <br />
                {{
                  assembleTooltip_groupKeyValue(
                    "电能",
                    ["Wp", "Wq"],
                    [energyActiveDehumidifierZ8B5RSteelBoxG15, energyReactiveDehumidifierZ8B5RSteelBoxG15],
                    ["kWh", "kvarh"]
                  )
                }}
                <br />
                {{ assembleTooltip_simpleKeyValue("频率", frequencyDehumidifierZ8B5RSteelBoxG15, "Hz") }}
              </div>
              <div :class="errorZ8B5RSteelBoxG15" class="state-info left-pos" @dblclick="hrefToScenario('ce3af0d0-21cf-40bc-b927-627d31a0a33b')"
                v-loading="stationNameLoadingDict['stationG15']">
                <p>
                  <span class="bold">Z8B5-R钢箱梁G15</span>
                  <span :class="runningClassZ8B5RSteelBoxG15" class="valve-sign"></span>
                </p>
                <p>
                  <span>电流</span>
                  <span>{{ currentADehumidifierZ8B5RSteelBoxG15 | toFixed }}A {{ currentBDehumidifierZ8B5RSteelBoxG15 |
                    toFixed }}A
                    {{ currentCDehumidifierZ8B5RSteelBoxG15 | toFixed }}A</span>
                </p>
                <p>
                  <span>电压</span>
                  <span>{{ voltageABDehumidifierZ8B5RSteelBoxG15 | toFixed }}V {{ voltageBCDehumidifierZ8B5RSteelBoxG15
                    | toFixed }}V
                    {{ voltageACDehumidifierZ8B5RSteelBoxG15 | toFixed }}V
                  </span>
                </p>
                <p>
                  <span>功率</span>
                  <span>{{ powerActiveDehumidifierZ8B5RSteelBoxG15 | toFixed }}kW {{
                    powerReactiveDehumidifierZ8B5RSteelBoxG15 | toFixed }}Kvar
                    {{ powerApparentDehumidifierZ8B5RSteelBoxG15 | toFixed }}kVA
                  </span>
                </p>
                <p>
                  <span>电能</span>
                  <span>{{ energyActiveDehumidifierZ8B5RSteelBoxG15 | toFixed }}kWh {{
                    energyReactiveDehumidifierZ8B5RSteelBoxG15 | toFixed }}kvarh</span>
                </p>
                <p>
                  <span>频率</span>
                  <span>{{ frequencyDehumidifierZ8B5RSteelBoxG15 | toFixed }}Hz</span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "jiashao",
      bridgeId: "3b04991c-3662-4948-930e-ac537ed82fd3",

      //humidity, temperature, pressure, flow, volume
      currentADehumidifierZ3B5LSteelBoxG1: "--",
      currentADehumidifierZ3B5RSteelBoxG2: "--",
      currentADehumidifierZ4B11LSteelBoxG3: "--",
      currentADehumidifierZ4B11RSteelBoxG4: "--",
      currentADehumidifierZ4Z8RSteelBoxG5: "--",
      currentADehumidifierZ4Z8LSteelBoxG6: "--",
      currentADehumidifierZ5Z1RSteelBoxG7: "--",
      currentADehumidifierZ5Z1LSteelBoxG8: "--",
      currentADehumidifierZ6Z1LSteelBoxG9: "--",
      currentADehumidifierZ6Z1RSteelBoxG10: "--",
      currentADehumidifierZ7Z8LSteelBoxG11: "--",
      currentADehumidifierZ7Z8RSteelBoxG12: "--",
      currentADehumidifierZ7B11RSteelBoxG13: "--",
      currentADehumidifierZ7B11LSteelBoxG14: "--",
      currentADehumidifierZ8B5RSteelBoxG15: "--",
      currentADehumidifierZ8B5LSteelBoxG16: "--",
      currentBDehumidifierZ3B5LSteelBoxG1: "--",
      currentBDehumidifierZ3B5RSteelBoxG2: "--",
      currentBDehumidifierZ4B11LSteelBoxG3: "--",
      currentBDehumidifierZ4B11RSteelBoxG4: "--",
      currentBDehumidifierZ4Z8RSteelBoxG5: "--",
      currentBDehumidifierZ4Z8LSteelBoxG6: "--",
      currentBDehumidifierZ5Z1RSteelBoxG7: "--",
      currentBDehumidifierZ5Z1LSteelBoxG8: "--",
      currentBDehumidifierZ6Z1LSteelBoxG9: "--",
      currentBDehumidifierZ6Z1RSteelBoxG10: "--",
      currentBDehumidifierZ7Z8LSteelBoxG11: "--",
      currentBDehumidifierZ7Z8RSteelBoxG12: "--",
      currentBDehumidifierZ7B11RSteelBoxG13: "--",
      currentBDehumidifierZ7B11LSteelBoxG14: "--",
      currentBDehumidifierZ8B5RSteelBoxG15: "--",
      currentBDehumidifierZ8B5LSteelBoxG16: "--",
      currentCDehumidifierZ3B5LSteelBoxG1: "--",
      currentCDehumidifierZ3B5RSteelBoxG2: "--",
      currentCDehumidifierZ4B11LSteelBoxG3: "--",
      currentCDehumidifierZ4B11RSteelBoxG4: "--",
      currentCDehumidifierZ4Z8RSteelBoxG5: "--",
      currentCDehumidifierZ4Z8LSteelBoxG6: "--",
      currentCDehumidifierZ5Z1RSteelBoxG7: "--",
      currentCDehumidifierZ5Z1LSteelBoxG8: "--",
      currentCDehumidifierZ6Z1LSteelBoxG9: "--",
      currentCDehumidifierZ6Z1RSteelBoxG10: "--",
      currentCDehumidifierZ7Z8LSteelBoxG11: "--",
      currentCDehumidifierZ7Z8RSteelBoxG12: "--",
      currentCDehumidifierZ7B11RSteelBoxG13: "--",
      currentCDehumidifierZ7B11LSteelBoxG14: "--",
      currentCDehumidifierZ8B5RSteelBoxG15: "--",
      currentCDehumidifierZ8B5LSteelBoxG16: "--",

      voltageABDehumidifierZ3B5LSteelBoxG1: "--",
      voltageABDehumidifierZ3B5RSteelBoxG2: "--",
      voltageABDehumidifierZ4B11LSteelBoxG3: "--",
      voltageABDehumidifierZ4B11RSteelBoxG4: "--",
      voltageABDehumidifierZ4Z8RSteelBoxG5: "--",
      voltageABDehumidifierZ4Z8LSteelBoxG6: "--",
      voltageABDehumidifierZ5Z1RSteelBoxG7: "--",
      voltageABDehumidifierZ5Z1LSteelBoxG8: "--",
      voltageABDehumidifierZ6Z1LSteelBoxG9: "--",
      voltageABDehumidifierZ6Z1RSteelBoxG10: "--",
      voltageABDehumidifierZ7Z8LSteelBoxG11: "--",
      voltageABDehumidifierZ7Z8RSteelBoxG12: "--",
      voltageABDehumidifierZ7B11RSteelBoxG13: "--",
      voltageABDehumidifierZ7B11LSteelBoxG14: "--",
      voltageABDehumidifierZ8B5RSteelBoxG15: "--",
      voltageABDehumidifierZ8B5LSteelBoxG16: "--",
      voltageBCDehumidifierZ3B5LSteelBoxG1: "--",
      voltageBCDehumidifierZ3B5RSteelBoxG2: "--",
      voltageBCDehumidifierZ4B11LSteelBoxG3: "--",
      voltageBCDehumidifierZ4B11RSteelBoxG4: "--",
      voltageBCDehumidifierZ4Z8RSteelBoxG5: "--",
      voltageBCDehumidifierZ4Z8LSteelBoxG6: "--",
      voltageBCDehumidifierZ5Z1RSteelBoxG7: "--",
      voltageBCDehumidifierZ5Z1LSteelBoxG8: "--",
      voltageBCDehumidifierZ6Z1LSteelBoxG9: "--",
      voltageBCDehumidifierZ6Z1RSteelBoxG10: "--",
      voltageBCDehumidifierZ7Z8LSteelBoxG11: "--",
      voltageBCDehumidifierZ7Z8RSteelBoxG12: "--",
      voltageBCDehumidifierZ7B11RSteelBoxG13: "--",
      voltageBCDehumidifierZ7B11LSteelBoxG14: "--",
      voltageBCDehumidifierZ8B5RSteelBoxG15: "--",
      voltageBCDehumidifierZ8B5LSteelBoxG16: "--",
      voltageACDehumidifierZ3B5LSteelBoxG1: "--",
      voltageACDehumidifierZ3B5RSteelBoxG2: "--",
      voltageACDehumidifierZ4B11LSteelBoxG3: "--",
      voltageACDehumidifierZ4B11RSteelBoxG4: "--",
      voltageACDehumidifierZ4Z8RSteelBoxG5: "--",
      voltageACDehumidifierZ4Z8LSteelBoxG6: "--",
      voltageACDehumidifierZ5Z1RSteelBoxG7: "--",
      voltageACDehumidifierZ5Z1LSteelBoxG8: "--",
      voltageACDehumidifierZ6Z1LSteelBoxG9: "--",
      voltageACDehumidifierZ6Z1RSteelBoxG10: "--",
      voltageACDehumidifierZ7Z8LSteelBoxG11: "--",
      voltageACDehumidifierZ7Z8RSteelBoxG12: "--",
      voltageACDehumidifierZ7B11RSteelBoxG13: "--",
      voltageACDehumidifierZ7B11LSteelBoxG14: "--",
      voltageACDehumidifierZ8B5RSteelBoxG15: "--",
      voltageACDehumidifierZ8B5LSteelBoxG16: "--",

      powerActiveDehumidifierZ3B5LSteelBoxG1: "--",
      powerActiveDehumidifierZ3B5RSteelBoxG2: "--",
      powerActiveDehumidifierZ4B11LSteelBoxG3: "--",
      powerActiveDehumidifierZ4B11RSteelBoxG4: "--",
      powerActiveDehumidifierZ4Z8RSteelBoxG5: "--",
      powerActiveDehumidifierZ4Z8LSteelBoxG6: "--",
      powerActiveDehumidifierZ5Z1RSteelBoxG7: "--",
      powerActiveDehumidifierZ5Z1LSteelBoxG8: "--",
      powerActiveDehumidifierZ6Z1LSteelBoxG9: "--",
      powerActiveDehumidifierZ6Z1RSteelBoxG10: "--",
      powerActiveDehumidifierZ7Z8LSteelBoxG11: "--",
      powerActiveDehumidifierZ7Z8RSteelBoxG12: "--",
      powerActiveDehumidifierZ7B11RSteelBoxG13: "--",
      powerActiveDehumidifierZ7B11LSteelBoxG14: "--",
      powerActiveDehumidifierZ8B5RSteelBoxG15: "--",
      powerActiveDehumidifierZ8B5LSteelBoxG16: "--",
      powerReactiveDehumidifierZ3B5LSteelBoxG1: "--",
      powerReactiveDehumidifierZ3B5RSteelBoxG2: "--",
      powerReactiveDehumidifierZ4B11LSteelBoxG3: "--",
      powerReactiveDehumidifierZ4B11RSteelBoxG4: "--",
      powerReactiveDehumidifierZ4Z8RSteelBoxG5: "--",
      powerReactiveDehumidifierZ4Z8LSteelBoxG6: "--",
      powerReactiveDehumidifierZ5Z1RSteelBoxG7: "--",
      powerReactiveDehumidifierZ5Z1LSteelBoxG8: "--",
      powerReactiveDehumidifierZ6Z1LSteelBoxG9: "--",
      powerReactiveDehumidifierZ6Z1RSteelBoxG10: "--",
      powerReactiveDehumidifierZ7Z8LSteelBoxG11: "--",
      powerReactiveDehumidifierZ7Z8RSteelBoxG12: "--",
      powerReactiveDehumidifierZ7B11RSteelBoxG13: "--",
      powerReactiveDehumidifierZ7B11LSteelBoxG14: "--",
      powerReactiveDehumidifierZ8B5RSteelBoxG15: "--",
      powerReactiveDehumidifierZ8B5LSteelBoxG16: "--",
      powerApparentDehumidifierZ3B5LSteelBoxG1: "--",
      powerApparentDehumidifierZ3B5RSteelBoxG2: "--",
      powerApparentDehumidifierZ4B11LSteelBoxG3: "--",
      powerApparentDehumidifierZ4B11RSteelBoxG4: "--",
      powerApparentDehumidifierZ4Z8RSteelBoxG5: "--",
      powerApparentDehumidifierZ4Z8LSteelBoxG6: "--",
      powerApparentDehumidifierZ5Z1RSteelBoxG7: "--",
      powerApparentDehumidifierZ5Z1LSteelBoxG8: "--",
      powerApparentDehumidifierZ6Z1LSteelBoxG9: "--",
      powerApparentDehumidifierZ6Z1RSteelBoxG10: "--",
      powerApparentDehumidifierZ7Z8LSteelBoxG11: "--",
      powerApparentDehumidifierZ7Z8RSteelBoxG12: "--",
      powerApparentDehumidifierZ7B11RSteelBoxG13: "--",
      powerApparentDehumidifierZ7B11LSteelBoxG14: "--",
      powerApparentDehumidifierZ8B5RSteelBoxG15: "--",
      powerApparentDehumidifierZ8B5LSteelBoxG16: "--",

      energyActiveDehumidifierZ3B5LSteelBoxG1: "--",
      energyActiveDehumidifierZ3B5RSteelBoxG2: "--",
      energyActiveDehumidifierZ4B11LSteelBoxG3: "--",
      energyActiveDehumidifierZ4B11RSteelBoxG4: "--",
      energyActiveDehumidifierZ4Z8RSteelBoxG5: "--",
      energyActiveDehumidifierZ4Z8LSteelBoxG6: "--",
      energyActiveDehumidifierZ5Z1RSteelBoxG7: "--",
      energyActiveDehumidifierZ5Z1LSteelBoxG8: "--",
      energyActiveDehumidifierZ6Z1LSteelBoxG9: "--",
      energyActiveDehumidifierZ6Z1RSteelBoxG10: "--",
      energyActiveDehumidifierZ7Z8LSteelBoxG11: "--",
      energyActiveDehumidifierZ7Z8RSteelBoxG12: "--",
      energyActiveDehumidifierZ7B11RSteelBoxG13: "--",
      energyActiveDehumidifierZ7B11LSteelBoxG14: "--",
      energyActiveDehumidifierZ8B5RSteelBoxG15: "--",
      energyActiveDehumidifierZ8B5LSteelBoxG16: "--",
      energyReactiveDehumidifierZ3B5LSteelBoxG1: "--",
      energyReactiveDehumidifierZ3B5RSteelBoxG2: "--",
      energyReactiveDehumidifierZ4B11LSteelBoxG3: "--",
      energyReactiveDehumidifierZ4B11RSteelBoxG4: "--",
      energyReactiveDehumidifierZ4Z8RSteelBoxG5: "--",
      energyReactiveDehumidifierZ4Z8LSteelBoxG6: "--",
      energyReactiveDehumidifierZ5Z1RSteelBoxG7: "--",
      energyReactiveDehumidifierZ5Z1LSteelBoxG8: "--",
      energyReactiveDehumidifierZ6Z1LSteelBoxG9: "--",
      energyReactiveDehumidifierZ6Z1RSteelBoxG10: "--",
      energyReactiveDehumidifierZ7Z8LSteelBoxG11: "--",
      energyReactiveDehumidifierZ7Z8RSteelBoxG12: "--",
      energyReactiveDehumidifierZ7B11RSteelBoxG13: "--",
      energyReactiveDehumidifierZ7B11LSteelBoxG14: "--",
      energyReactiveDehumidifierZ8B5RSteelBoxG15: "--",
      energyReactiveDehumidifierZ8B5LSteelBoxG16: "--",

      frequencyDehumidifierZ3B5LSteelBoxG1: "--",
      frequencyDehumidifierZ3B5RSteelBoxG2: "--",
      frequencyDehumidifierZ4B11LSteelBoxG3: "--",
      frequencyDehumidifierZ4B11RSteelBoxG4: "--",
      frequencyDehumidifierZ4Z8RSteelBoxG5: "--",
      frequencyDehumidifierZ4Z8LSteelBoxG6: "--",
      frequencyDehumidifierZ5Z1RSteelBoxG7: "--",
      frequencyDehumidifierZ5Z1LSteelBoxG8: "--",
      frequencyDehumidifierZ6Z1LSteelBoxG9: "--",
      frequencyDehumidifierZ6Z1RSteelBoxG10: "--",
      frequencyDehumidifierZ7Z8LSteelBoxG11: "--",
      frequencyDehumidifierZ7Z8RSteelBoxG12: "--",
      frequencyDehumidifierZ7B11RSteelBoxG13: "--",
      frequencyDehumidifierZ7B11LSteelBoxG14: "--",
      frequencyDehumidifierZ8B5RSteelBoxG15: "--",
      frequencyDehumidifierZ8B5LSteelBoxG16: "--",

      //running
      runningDehumidifierZ3B5LSteelBoxG1: "--",
      runningDehumidifierZ3TowerMid: "--",
      runningDehumidifierZ4TowerTop: "--",
      runningDehumidifierZ4TowerMid: "--",
      runningDehumidifierZ5TowerTop: "--",
      runningDehumidifierZ5TowerMid: "--",
      runningDehumidifierZ6TowerTop: "--",
      runningDehumidifierZ6TowerMid: "--",
      runningDehumidifierZ7TowerTop: "--",
      runningDehumidifierZ7TowerMid: "--",
      runningDehumidifierZ8TowerTop: "--",
      runningDehumidifierZ8TowerMid: "--",
      runningDehumidifierZ3B5LSteelBoxG1: "--",
      runningDehumidifierZ3B5RSteelBoxG2: "--",
      runningDehumidifierZ4B11LSteelBoxG3: "--",
      runningDehumidifierZ4B11RSteelBoxG4: "--",
      runningDehumidifierZ4Z8RSteelBoxG5: "--",
      runningDehumidifierZ4Z8LSteelBoxG6: "--",
      runningDehumidifierZ5Z1RSteelBoxG7: "--",
      runningDehumidifierZ5Z1LSteelBoxG8: "--",
      runningDehumidifierZ6Z1LSteelBoxG9: "--",
      runningDehumidifierZ6Z1RSteelBoxG10: "--",
      runningDehumidifierZ7Z8LSteelBoxG11: "--",
      runningDehumidifierZ7Z8RSteelBoxG12: "--",
      runningDehumidifierZ7B11RSteelBoxG13: "--",
      runningDehumidifierZ7B11LSteelBoxG14: "--",
      runningDehumidifierZ8B5RSteelBoxG15: "--",
      runningDehumidifierZ8B5LSteelBoxG16: "--",

      //malfunction
      malfunctionDehumidifierZ3B5LSteelBoxG1: "--",
      malfunctionDehumidifierZ3TowerMid: "--",
      malfunctionDehumidifierZ4TowerTop: "--",
      malfunctionDehumidifierZ4TowerMid: "--",
      malfunctionDehumidifierZ5TowerTop: "--",
      malfunctionDehumidifierZ5TowerMid: "--",
      malfunctionDehumidifierZ6TowerTop: "--",
      malfunctionDehumidifierZ6TowerMid: "--",
      malfunctionDehumidifierZ7TowerTop: "--",
      malfunctionDehumidifierZ7TowerMid: "--",
      malfunctionDehumidifierZ8TowerTop: "--",
      malfunctionDehumidifierZ8TowerMid: "--",
      malfunctionDehumidifierZ3B5LSteelBoxG1: "--",
      malfunctionDehumidifierZ3B5RSteelBoxG2: "--",
      malfunctionDehumidifierZ4B11LSteelBoxG3: "--",
      malfunctionDehumidifierZ4B11RSteelBoxG4: "--",
      malfunctionDehumidifierZ4Z8RSteelBoxG5: "--",
      malfunctionDehumidifierZ4Z8LSteelBoxG6: "--",
      malfunctionDehumidifierZ5Z1RSteelBoxG7: "--",
      malfunctionDehumidifierZ5Z1LSteelBoxG8: "--",
      malfunctionDehumidifierZ6Z1LSteelBoxG9: "--",
      malfunctionDehumidifierZ6Z1RSteelBoxG10: "--",
      malfunctionDehumidifierZ7Z8LSteelBoxG11: "--",
      malfunctionDehumidifierZ7Z8RSteelBoxG12: "--",
      malfunctionDehumidifierZ7B11RSteelBoxG13: "--",
      malfunctionDehumidifierZ7B11LSteelBoxG14: "--",
      malfunctionDehumidifierZ8B5RSteelBoxG15: "--",
      malfunctionDehumidifierZ8B5LSteelBoxG16: "--",

      //error
      errorZ3TowerTop: "--",
      errorZ3TowerMid: "--",
      errorZ4TowerTop: "--",
      errorZ4TowerMid: "--",
      errorZ5TowerTop: "--",
      errorZ5TowerMid: "--",
      errorZ6TowerTop: "--",
      errorZ6TowerMid: "--",
      errorZ7TowerTop: "--",
      errorZ7TowerMid: "--",
      errorZ8TowerTop: "--",
      errorZ8TowerMid: "--",
      errorZ3B5LSteelBoxG1: "--",
      errorZ3B5RSteelBoxG2: "--",
      errorZ4B11LSteelBoxG3: "--",
      errorZ4B11RSteelBoxG4: "--",
      errorZ4Z8RSteelBoxG5: "--",
      errorZ4Z8LSteelBoxG6: "--",
      errorZ5Z1RSteelBoxG7: "--",
      errorZ5Z1LSteelBoxG8: "--",
      errorZ6Z1LSteelBoxG9: "--",
      errorZ6Z1RSteelBoxG10: "--",
      errorZ7Z8LSteelBoxG11: "--",
      errorZ7Z8RSteelBoxG12: "--",
      errorZ7B11RSteelBoxG13: "--",
      errorZ7B11LSteelBoxG14: "--",
      errorZ8B5RSteelBoxG15: "--",
      errorZ8B5LSteelBoxG16: "--",

      //running class
      runningClassZ3TowerTop: "--",
      runningClassZ3TowerMid: "--",
      runningClassZ4TowerTop: "--",
      runningClassZ4TowerMid: "--",
      runningClassZ5TowerTop: "--",
      runningClassZ5TowerMid: "--",
      runningClassZ6TowerTop: "--",
      runningClassZ6TowerMid: "--",
      runningClassZ7TowerTop: "--",
      runningClassZ7TowerMid: "--",
      runningClassZ8TowerTop: "--",
      runningClassZ8TowerMid: "--",
      runningClassZ3B5LSteelBoxG1: "--",
      runningClassZ3B5RSteelBoxG2: "--",
      runningClassZ4B11LSteelBoxG3: "--",
      runningClassZ4B11RSteelBoxG4: "--",
      runningClassZ4Z8RSteelBoxG5: "--",
      runningClassZ4Z8LSteelBoxG6: "--",
      runningClassZ5Z1RSteelBoxG7: "--",
      runningClassZ5Z1LSteelBoxG8: "--",
      runningClassZ6Z1LSteelBoxG9: "--",
      runningClassZ6Z1RSteelBoxG10: "--",
      runningClassZ7Z8LSteelBoxG11: "--",
      runningClassZ7Z8RSteelBoxG12: "--",
      runningClassZ7B11RSteelBoxG13: "--",
      runningClassZ7B11LSteelBoxG14: "--",
      runningClassZ8B5RSteelBoxG15: "--",
      runningClassZ8B5LSteelBoxG16: "--",

      //humidity allowed max

      //humidity tooltip error

      dataNameIdDict: {
        //humidity, temperature
        currentADehumidifierZ3B5LSteelBoxG1: "30499a58-ff70-4da3-8eb7-ad20663b9d37",
        currentBDehumidifierZ3B5LSteelBoxG1: "619266af-1181-4198-92c3-433514ef6fa8",
        currentCDehumidifierZ3B5LSteelBoxG1: "dcfc8237-206c-409e-b413-d66d96c67ba0",
        currentADehumidifierZ3B5RSteelBoxG2: "3fb0958c-52b1-41f5-b170-dadd87457299",
        currentBDehumidifierZ3B5RSteelBoxG2: "9c3dd733-b73f-4cf0-bef0-7a1e918b5393",
        currentCDehumidifierZ3B5RSteelBoxG2: "b9efb05f-2897-472e-8339-1a360f6866fc",
        currentADehumidifierZ4B11LSteelBoxG3: "6e53f753-4507-4f95-b65f-7745e99c3880",
        currentBDehumidifierZ4B11LSteelBoxG3: "450e427b-cb20-4e39-8172-e0625c2cc618",
        currentCDehumidifierZ4B11LSteelBoxG3: "4115f86a-4bc5-4708-8499-07a4dca59eeb",
        currentADehumidifierZ4B11RSteelBoxG4: "f37c7599-68ee-4581-b008-eb71b2470c42",
        currentBDehumidifierZ4B11RSteelBoxG4: "7675a703-abd4-4dba-bf31-b5d1680e1ef5",
        currentCDehumidifierZ4B11RSteelBoxG4: "f12c9b6c-5bb5-4234-9226-a76ec4264f52",
        currentADehumidifierZ4Z8LSteelBoxG6: "c8525e7f-dec0-4e66-88d5-a66d71f833d4",
        currentBDehumidifierZ4Z8LSteelBoxG6: "4696522a-e3d3-4626-88a1-44605e512736",
        currentCDehumidifierZ4Z8LSteelBoxG6: "01f1ec61-e641-4620-bfbd-2690431c0fd6",
        currentADehumidifierZ4Z8RSteelBoxG5: "985319fe-a5ca-4e88-9234-d6a312e9cc07",
        currentBDehumidifierZ4Z8RSteelBoxG5: "6e072560-7382-489d-9d2c-cfc19d64e4c2",
        currentCDehumidifierZ4Z8RSteelBoxG5: "cd71f35f-b9de-4385-bcf2-3a00838174ab",
        currentADehumidifierZ5Z1LSteelBoxG8: "f7fd4594-8730-4801-9cc6-e788c55adfed",
        currentBDehumidifierZ5Z1LSteelBoxG8: "f12630ea-8b6e-4111-9fd2-91970bdb4baa",
        currentCDehumidifierZ5Z1LSteelBoxG8: "375921c4-825e-47fe-89fc-13e92000ec44",
        currentADehumidifierZ5Z1RSteelBoxG7: "fe8d1bdd-ea3e-439d-8f7c-6f66382fc75a",
        currentBDehumidifierZ5Z1RSteelBoxG7: "8e9cf612-475f-4c1a-b159-6e0f0936dc0f",
        currentCDehumidifierZ5Z1RSteelBoxG7: "a4246aeb-1ef7-4eff-b546-5d7fb6d88235",
        currentADehumidifierZ6Z1LSteelBoxG9: "db3f5841-6e47-439e-ae28-f6f8bd8273a4",
        currentBDehumidifierZ6Z1LSteelBoxG9: "8c420476-3123-4a02-80e6-e083de5f19c6",
        currentCDehumidifierZ6Z1LSteelBoxG9: "2d7c14d6-6908-44e1-bb0c-cfa71887dfd0",
        currentADehumidifierZ6Z1RSteelBoxG10: "6d67e56b-d8d9-44bf-a43d-6d93a021e997",
        currentBDehumidifierZ6Z1RSteelBoxG10: "e64ecc3f-2c02-4a82-a719-75f6c36f5e42",
        currentCDehumidifierZ6Z1RSteelBoxG10: "4c37a2a1-67ce-4583-9dd7-784641f9b2f5",
        currentADehumidifierZ7B11LSteelBoxG14: "494a486e-3e9e-471f-a059-ad5db1b47710",
        currentBDehumidifierZ7B11LSteelBoxG14: "88e6aeaf-bb2e-42cb-aa54-07fe24326e99",
        currentCDehumidifierZ7B11LSteelBoxG14: "ffa15b57-cd34-47e8-ae8c-c968864a7efb",
        currentADehumidifierZ7B11RSteelBoxG13: "d6e745e1-49b6-4286-994a-855762983158",
        currentBDehumidifierZ7B11RSteelBoxG13: "5e2826c7-e51f-47e4-b20f-bcce2eeeeebc",
        currentCDehumidifierZ7B11RSteelBoxG13: "1b74e3a5-ddc8-4a3f-b3f1-73d0bdec1a26",
        currentADehumidifierZ7Z8LSteelBoxG11: "be6e55f5-e63c-452a-b6e4-873a8d56069b",
        currentBDehumidifierZ7Z8LSteelBoxG11: "1ff06c65-c2bf-4860-9361-cba1c19328ff",
        currentCDehumidifierZ7Z8LSteelBoxG11: "826c17c0-c384-40a5-9bea-cdacf108f5d4",
        currentADehumidifierZ7Z8RSteelBoxG12: "91cd0dac-6523-406c-aa61-4b00fdec8f94",
        currentBDehumidifierZ7Z8RSteelBoxG12: "d0edc66d-0352-4eac-8fe1-e115adbdcc97",
        currentCDehumidifierZ7Z8RSteelBoxG12: "ef16a4f8-ca8a-46e8-8a3a-493a45efa0c3",
        currentADehumidifierZ8B5LSteelBoxG16: "096a0bfe-6ef7-4877-b4ae-c8632d48b9dc",
        currentBDehumidifierZ8B5LSteelBoxG16: "972184fb-d363-46ee-9d60-19c434a3d346",
        currentCDehumidifierZ8B5LSteelBoxG16: "d6c342bd-20c0-401b-b062-ea79e60ee6fb",
        currentADehumidifierZ8B5RSteelBoxG15: "29dda30d-f559-4548-8e6b-abd81460e583",
        currentBDehumidifierZ8B5RSteelBoxG15: "aec2487f-ef28-4298-ae10-f46c6bfe88ef",
        currentCDehumidifierZ8B5RSteelBoxG15: "16268530-08d1-493b-a864-d2a11a0dc2d8",

        voltageABDehumidifierZ3B5LSteelBoxG1: "9c33c582-9532-4937-bdcd-5da63b50abf8",
        voltageACDehumidifierZ3B5LSteelBoxG1: "f24b12d9-df67-48b4-8cc4-7d23a5a71177",
        voltageBCDehumidifierZ3B5LSteelBoxG1: "cee21451-4871-478e-801e-661482e84d14",
        voltageABDehumidifierZ3B5RSteelBoxG2: "c0a42103-7651-4ac0-97ed-fd90b6a5cd70",
        voltageACDehumidifierZ3B5RSteelBoxG2: "a25ed2b1-4e04-45ca-8d04-d4e6fdfc47d0",
        voltageBCDehumidifierZ3B5RSteelBoxG2: "f568c6e3-40f7-4ca3-8f43-1cb8e7a366d2",
        voltageABDehumidifierZ4B11LSteelBoxG3: "49816105-15d7-46e2-90e1-7e88d968480f",
        voltageACDehumidifierZ4B11LSteelBoxG3: "8fc302f7-7e13-4f5d-9ca9-3bd4596cc10f",
        voltageBCDehumidifierZ4B11LSteelBoxG3: "75cf063f-eadd-4430-ac85-463d89a0cf30",
        voltageABDehumidifierZ4B11RSteelBoxG4: "f9cf37e8-e51b-4681-8849-0f49a51b588c",
        voltageACDehumidifierZ4B11RSteelBoxG4: "f2cdfa08-e781-4d48-8a01-e404bda2a82a",
        voltageBCDehumidifierZ4B11RSteelBoxG4: "62c98e52-d07b-4605-aaea-49e86683c775",
        voltageABDehumidifierZ4Z8LSteelBoxG6: "812b42bb-156d-4831-a4ed-c10d6c89ebbe",
        voltageACDehumidifierZ4Z8LSteelBoxG6: "568a53ec-db7a-467a-b62e-d98fc0dcd5bb",
        voltageBCDehumidifierZ4Z8LSteelBoxG6: "d242a769-d6a5-4b04-a786-647abcb959fe",
        voltageABDehumidifierZ4Z8RSteelBoxG5: "bd5c5821-57b7-4730-a397-98cc0f74b6df",
        voltageACDehumidifierZ4Z8RSteelBoxG5: "9e8a6a66-60a2-4b77-af00-ae12e566df18",
        voltageBCDehumidifierZ4Z8RSteelBoxG5: "db3e2e59-0678-4e8c-b513-c8ca980da364",
        voltageABDehumidifierZ5Z1LSteelBoxG8: "3a821497-fa70-4e4e-8933-5fe784dd2e3d",
        voltageACDehumidifierZ5Z1LSteelBoxG8: "d2d51ca7-4a77-40b5-bdf0-00a2461fbd04",
        voltageBCDehumidifierZ5Z1LSteelBoxG8: "19512dab-4b52-4020-b7b5-0af8f8b20070",
        voltageABDehumidifierZ5Z1RSteelBoxG7: "aebc28b0-c538-4c3c-9ffc-ee15c7eb2005",
        voltageACDehumidifierZ5Z1RSteelBoxG7: "f7fd7450-ef19-4522-bb1e-d539c07fa319",
        voltageBCDehumidifierZ5Z1RSteelBoxG7: "b85344f5-f443-4626-9f67-94230247520a",
        voltageABDehumidifierZ6Z1LSteelBoxG9: "5a8eb8c2-b712-4799-8bc5-cbee43721dac",
        voltageACDehumidifierZ6Z1LSteelBoxG9: "298dc49c-ce53-4540-b79b-a7be89996ca8",
        voltageBCDehumidifierZ6Z1LSteelBoxG9: "f1724827-9a4b-43a6-8a05-ed2b6b127e59",
        voltageABDehumidifierZ6Z1RSteelBoxG10: "997ea93e-0e3a-4c26-bdc9-588c5d0c8b7f",
        voltageACDehumidifierZ6Z1RSteelBoxG10: "4f2fa1f0-be1a-4345-856c-37739df34cc4",
        voltageBCDehumidifierZ6Z1RSteelBoxG10: "9a67ce31-2759-4df2-bd0e-8c568610f2b9",
        voltageABDehumidifierZ7B11LSteelBoxG14: "e4f513c3-eb6b-44ec-a462-a13a5747a4b9",
        voltageACDehumidifierZ7B11LSteelBoxG14: "09c3f9e7-8b31-4e0d-9ef1-93e69457f62f",
        voltageBCDehumidifierZ7B11LSteelBoxG14: "a2884373-973c-4ce5-9ea7-232f207d94bc",
        voltageABDehumidifierZ7B11RSteelBoxG13: "88c8380a-3bf4-421b-b18d-ea3e157ac56d",
        voltageACDehumidifierZ7B11RSteelBoxG13: "86a8d8b4-23f1-4d4c-98f2-695126284acd",
        voltageBCDehumidifierZ7B11RSteelBoxG13: "d4f040ea-278f-402a-922b-5630cbbd1ec1",
        voltageABDehumidifierZ7Z8LSteelBoxG11: "0641370a-26cb-48e0-8340-3ef97c6bd816",
        voltageACDehumidifierZ7Z8LSteelBoxG11: "c635d7a0-6698-4d31-94db-a0ab2089aa74",
        voltageBCDehumidifierZ7Z8LSteelBoxG11: "a81f87dc-983d-4dd2-8e52-502346b4d5a8",
        voltageABDehumidifierZ7Z8RSteelBoxG12: "688f3138-1fe3-4b0e-a198-8934f62155e0",
        voltageACDehumidifierZ7Z8RSteelBoxG12: "b377781e-aac8-4820-9e79-2fc3f25cbb9a",
        voltageBCDehumidifierZ7Z8RSteelBoxG12: "17e313f7-5f02-4aac-a278-ae6f0c708ae0",
        voltageABDehumidifierZ8B5LSteelBoxG16: "e7e50679-4c60-474a-93aa-23f26a0b7d7b",
        voltageACDehumidifierZ8B5LSteelBoxG16: "4a19aa2f-6c83-4ffa-81da-583de6dd60ea",
        voltageBCDehumidifierZ8B5LSteelBoxG16: "ee46b79a-d7f6-4bb9-b454-b5fca87250d3",
        voltageABDehumidifierZ8B5RSteelBoxG15: "ee825ce7-307a-45c1-a97b-1a5026c66e96",
        voltageACDehumidifierZ8B5RSteelBoxG15: "8da9b3fc-a067-4e79-9847-ca7b7d811ea2",
        voltageBCDehumidifierZ8B5RSteelBoxG15: "1036a225-ea82-4942-bc74-a7deb25f1ea7",

        powerActiveDehumidifierZ3B5LSteelBoxG1: "d7e1f89d-e92e-4bf7-a513-0f293f9c5148",
        powerApparentDehumidifierZ3B5LSteelBoxG1: "674c7ac1-76c9-4cb2-8508-0ff6fc4ac786",
        powerReactiveDehumidifierZ3B5LSteelBoxG1: "ef7ad0ba-faf6-4d71-9240-6d2dde6ab6d0",
        powerActiveDehumidifierZ3B5RSteelBoxG2: "57fcf392-a5a0-43c2-909b-021be56b087d",
        powerApparentDehumidifierZ3B5RSteelBoxG2: "3be1d84d-3ad1-42ac-a404-869585a4614d",
        powerReactiveDehumidifierZ3B5RSteelBoxG2: "9854b4d1-89bc-4e28-8617-b81a50fa137b",
        powerActiveDehumidifierZ4B11LSteelBoxG3: "7b995190-08e0-49e3-a22c-c5dd4df12921",
        powerApparentDehumidifierZ4B11LSteelBoxG3: "9589f98a-2fa1-479c-ae96-84d400cc427e",
        powerReactiveDehumidifierZ4B11LSteelBoxG3: "55125eea-a277-4b04-b39c-b1a48ed05b6a",
        powerActiveDehumidifierZ4B11RSteelBoxG4: "cdd3aedb-1100-4bcf-a4ef-1eba9ae79754",
        powerApparentDehumidifierZ4B11RSteelBoxG4: "5207d0a4-af64-45ed-b1a2-303c28a8860d",
        powerReactiveDehumidifierZ4B11RSteelBoxG4: "f488865e-c2d3-4189-92de-d8b54a9a5084",
        powerActiveDehumidifierZ4Z8LSteelBoxG6: "792f1300-1790-48b7-ad78-3d28cb657649",
        powerApparentDehumidifierZ4Z8LSteelBoxG6: "580c6c0b-777d-435f-b367-dcf134406bcf",
        powerReactiveDehumidifierZ4Z8LSteelBoxG6: "cf62599a-1a78-42c4-bd8f-f7f22bbc1bdb",
        powerActiveDehumidifierZ4Z8RSteelBoxG5: "03d5556c-05a1-4906-89ba-3d2ae31f471e",
        powerApparentDehumidifierZ4Z8RSteelBoxG5: "0570805f-05d1-4232-8c71-30829d03c34a",
        powerReactiveDehumidifierZ4Z8RSteelBoxG5: "f04b93da-c35c-4e93-a4c8-48ec7369db71",
        powerActiveDehumidifierZ5Z1LSteelBoxG8: "6b2395ee-4f5f-45b9-bd0c-fe7e30bd8efd",
        powerApparentDehumidifierZ5Z1LSteelBoxG8: "c55365cb-3495-4c7b-a9e2-67ff4774ed70",
        powerReactiveDehumidifierZ5Z1LSteelBoxG8: "59cbdc5c-6e86-4245-834e-26b3d918b318",
        powerActiveDehumidifierZ5Z1RSteelBoxG7: "c22f3b7c-7935-4cc4-b3c8-fec397f2baa1",
        powerApparentDehumidifierZ5Z1RSteelBoxG7: "834842d0-a038-461d-8b02-fb3b354e99b7",
        powerReactiveDehumidifierZ5Z1RSteelBoxG7: "5f2c81f0-3c7c-41a5-b49e-32b35559e760",
        powerActiveDehumidifierZ6Z1LSteelBoxG9: "fdec4dbf-eec2-4373-910a-accd04fba755",
        powerApparentDehumidifierZ6Z1LSteelBoxG9: "74e95105-bc26-4239-8cce-6d538fc00b40",
        powerReactiveDehumidifierZ6Z1LSteelBoxG9: "df9f2404-afda-4922-b2c2-c7b0e840383b",
        powerActiveDehumidifierZ6Z1RSteelBoxG10: "cf5fdc66-0471-4d67-ac42-2d65ba37da71",
        powerApparentDehumidifierZ6Z1RSteelBoxG10: "daaaef9a-e7fb-4c2a-95ea-1e58340c0378",
        powerReactiveDehumidifierZ6Z1RSteelBoxG10: "5b645cca-e0e7-4e0f-ab7a-1be5f2de76b5",
        powerActiveDehumidifierZ7B11LSteelBoxG14: "04d0a2ad-2d62-4556-843f-8f72b6041ddb",
        powerApparentDehumidifierZ7B11LSteelBoxG14: "d9184d7c-132c-4e04-a0c8-d48d3e2a5560",
        powerReactiveDehumidifierZ7B11LSteelBoxG14: "8b1a501e-512a-45dd-b238-df233717f302",
        powerActiveDehumidifierZ7B11RSteelBoxG13: "a9f28f65-3f80-495f-83e5-276b28be7116",
        powerApparentDehumidifierZ7B11RSteelBoxG13: "001e8ae7-ac0b-4e58-b66e-d9ae1e85ab17",
        powerReactiveDehumidifierZ7B11RSteelBoxG13: "5ebd23e2-4d56-4eaf-b5d8-5de06876e2bc",
        powerActiveDehumidifierZ7Z8LSteelBoxG11: "1c3c01f2-bc90-4be0-8ad4-ea4b16fdb30b",
        powerApparentDehumidifierZ7Z8LSteelBoxG11: "67811d9e-1231-4633-81a4-288be4501d5f",
        powerReactiveDehumidifierZ7Z8LSteelBoxG11: "c16e0d0e-6ebd-4e86-8a80-333c79b2c736",
        powerActiveDehumidifierZ7Z8RSteelBoxG12: "ffbaeb1a-4482-42c8-8301-b1657533b0f4",
        powerApparentDehumidifierZ7Z8RSteelBoxG12: "270a077b-91ca-4918-85de-b8b3bbb80622",
        powerReactiveDehumidifierZ7Z8RSteelBoxG12: "a883ca34-eae9-4a32-8b27-d70515d45f27",
        powerActiveDehumidifierZ8B5LSteelBoxG16: "5719f860-f1cc-4f77-b5d9-dd294361a9da",
        powerApparentDehumidifierZ8B5LSteelBoxG16: "d45a1776-b429-43f7-9e9d-3a7fa2de4c6e",
        powerReactiveDehumidifierZ8B5LSteelBoxG16: "52842ba5-53f9-4e36-9258-08ade73211e7",
        powerActiveDehumidifierZ8B5RSteelBoxG15: "0a2ca1af-29bb-4b7a-9034-1b474ef0fd74",
        powerApparentDehumidifierZ8B5RSteelBoxG15: "3b1db2d2-bd76-46c8-9d9b-7d0c88590b78",
        powerReactiveDehumidifierZ8B5RSteelBoxG15: "ae26f31f-e7ba-46e0-bbcf-21ccdd2b79b9",

        energyActiveDehumidifierZ3B5LSteelBoxG1: "46d09b98-6b7f-4ffc-8eff-5bd7d2bab668",
        energyReactiveDehumidifierZ3B5LSteelBoxG1: "c012ddd7-9821-4262-a039-2802e415f3ec",
        energyActiveDehumidifierZ3B5RSteelBoxG2: "a15ff363-26ee-4155-a51d-5d99d565952d",
        energyReactiveDehumidifierZ3B5RSteelBoxG2: "7a568cd4-183d-4f6a-b3b9-821e8c636a48",
        energyActiveDehumidifierZ4B11LSteelBoxG3: "097fa74b-3f1a-4045-98cf-c7db09312ba3",
        energyReactiveDehumidifierZ4B11LSteelBoxG3: "288b26b2-878c-482f-9e33-8afce5bafe78",
        energyActiveDehumidifierZ4B11RSteelBoxG4: "65b4c6c6-4018-42df-89c1-e7fa71102432",
        energyReactiveDehumidifierZ4B11RSteelBoxG4: "6fda4f4d-0225-4bac-a3fe-5aa647b1a941",
        energyActiveDehumidifierZ4Z8LSteelBoxG6: "b7e075ce-8ab6-4d04-86e8-b4bd014b6d8c",
        energyReactiveDehumidifierZ4Z8LSteelBoxG6: "55bba7a4-6f01-4fff-ba88-4b855487e4f6",
        energyActiveDehumidifierZ4Z8RSteelBoxG5: "4261fa1a-ae80-4149-9065-7f4f58e33de6",
        energyReactiveDehumidifierZ4Z8RSteelBoxG5: "d3b3108f-3f09-45cd-a87f-e08ba1d5df8b",
        energyActiveDehumidifierZ5Z1LSteelBoxG8: "ad535d55-2474-4222-b4ff-d7e17c786db3",
        energyReactiveDehumidifierZ5Z1LSteelBoxG8: "4fb86284-9197-42e1-b10a-fc385ed44928",
        energyActiveDehumidifierZ5Z1RSteelBoxG7: "c5fb6818-267e-443b-a54b-292b12b2353b",
        energyReactiveDehumidifierZ5Z1RSteelBoxG7: "aef8fae5-c4c2-4db5-9858-872f6511ee01",
        energyActiveDehumidifierZ6Z1LSteelBoxG9: "6161c61f-08ef-4f82-ada0-95a55aeae095",
        energyReactiveDehumidifierZ6Z1LSteelBoxG9: "80115f51-0a2f-4a8f-b39e-bb142be208b6",
        energyActiveDehumidifierZ6Z1RSteelBoxG10: "a40ca794-4b26-40f5-9231-bb9430a5f11a",
        energyReactiveDehumidifierZ6Z1RSteelBoxG10: "b17843bd-7816-4f78-9149-ea516b1d9ad7",
        energyActiveDehumidifierZ7B11LSteelBoxG14: "ddbe4d12-d09f-4787-9955-6a62f40dc024",
        energyReactiveDehumidifierZ7B11LSteelBoxG14: "88524bac-432a-4e4c-9304-edce76bca04d",
        energyActiveDehumidifierZ7B11RSteelBoxG13: "8f4741e8-0e38-4934-9f1b-46b406536bc1",
        energyReactiveDehumidifierZ7B11RSteelBoxG13: "940f4888-a892-49fd-8b3f-bf59a2b63b8e",
        energyActiveDehumidifierZ7Z8LSteelBoxG11: "8ef3ab95-d72b-4ff7-8cd4-de6fa8dbda4d",
        energyReactiveDehumidifierZ7Z8LSteelBoxG11: "00200f1d-1a1d-4029-8b11-98c4afbceb58",
        energyActiveDehumidifierZ7Z8RSteelBoxG12: "94660612-25c4-4e62-ac26-1a59f6c22429",
        energyReactiveDehumidifierZ7Z8RSteelBoxG12: "5eaee4a8-30b1-40ab-8968-b95cdeef8404",
        energyActiveDehumidifierZ8B5LSteelBoxG16: "5f37e566-b424-44f3-867a-03b3623fa275",
        energyReactiveDehumidifierZ8B5LSteelBoxG16: "7841c077-4253-4605-9cc0-bdf1dc959888",
        energyActiveDehumidifierZ8B5RSteelBoxG15: "0e18cfc7-2afe-4184-93bc-086afb85870c",
        energyReactiveDehumidifierZ8B5RSteelBoxG15: "3255e1ed-2dfc-4705-be4b-14155bbcff7b",

        frequencyDehumidifierZ3B5LSteelBoxG1: "2d5495d8-cc78-429d-8853-23269a5583b1",
        frequencyDehumidifierZ3B5RSteelBoxG2: "9941c126-1285-4e87-828c-8b433d1560b2",
        frequencyDehumidifierZ4B11LSteelBoxG3: "7ba97170-bf20-40aa-b110-92341ac9e849",
        frequencyDehumidifierZ4B11RSteelBoxG4: "02dcb6c6-8cea-46e7-842c-624405480b86",
        frequencyDehumidifierZ4Z8LSteelBoxG6: "dd59b0b1-5775-4ec2-b64a-f3904aab0e0b",
        frequencyDehumidifierZ4Z8RSteelBoxG5: "6a1b3bb1-5ffd-4265-9139-bbb1f65a13fb",
        frequencyDehumidifierZ5Z1LSteelBoxG8: "337c3256-c66f-420b-91d0-3e0e08bb1654",
        frequencyDehumidifierZ5Z1RSteelBoxG7: "b426dde2-be58-4ccb-a912-eab713f073b6",
        frequencyDehumidifierZ6Z1LSteelBoxG9: "11b09b75-c323-4ca7-9876-814288faa329",
        frequencyDehumidifierZ6Z1RSteelBoxG10: "319443d9-44bd-4db5-822a-7f88f674fa09",
        frequencyDehumidifierZ7B11LSteelBoxG14: "75b80d17-4490-46ac-8ea6-68e1a65fb02e",
        frequencyDehumidifierZ7B11RSteelBoxG13: "3f94cb19-53c1-4f1c-9e67-cfeb8b054bbb",
        frequencyDehumidifierZ7Z8LSteelBoxG11: "6c2d0d2c-7463-43f8-a002-20e68b427969",
        frequencyDehumidifierZ7Z8RSteelBoxG12: "4d603792-232e-42f6-a699-3822104386ea",
        frequencyDehumidifierZ8B5LSteelBoxG16: "77fd2fc6-39be-4d2e-90e6-6d89a7028a27",
        frequencyDehumidifierZ8B5RSteelBoxG15: "f6e3bd1b-a58a-4956-8607-d03ce34cb561",

        //running
        runningDehumidifierZ3B5LSteelBoxG1: "3f760715-e5b5-4a19-9817-4139c7fcc849",
        runningDehumidifierZ3B5RSteelBoxG2: "2efaf149-fbc1-4155-a52f-c55d0ea3c456",
        runningDehumidifierZ4B11LSteelBoxG3: "6efbbbd4-c033-48e8-bca9-76e8f9301a3a",
        runningDehumidifierZ4B11RSteelBoxG4: "abe92405-ff9b-4f81-93f3-67dc6dd32596",
        runningDehumidifierZ4Z8LSteelBoxG6: "feb84c8f-d823-431c-9c9e-e53dec196648",
        runningDehumidifierZ4Z8RSteelBoxG5: "440b1302-6626-4354-adff-c0a9723d1528",
        runningDehumidifierZ5Z1LSteelBoxG8: "ed28cbe2-3f9c-4ee0-98e7-05079525edf5",
        runningDehumidifierZ5Z1RSteelBoxG7: "1808479c-6e6c-4803-917d-cb5c5badf41d",
        runningDehumidifierZ6Z1LSteelBoxG9: "4cde3b29-a364-40e4-8270-b18c66d66db3",
        runningDehumidifierZ6Z1RSteelBoxG10: "b09a3b64-b54b-442b-bcb2-236c870955f9",
        runningDehumidifierZ7B11LSteelBoxG14: "2b2f4ace-157f-4c6f-bd58-0b9d239a1b42",
        runningDehumidifierZ7B11RSteelBoxG13: "13fd41f5-7b1c-45d6-90c5-ffbf46a28117",
        runningDehumidifierZ7Z8LSteelBoxG11: "5c064244-e162-4914-b5d7-6d6d5ef276d6",
        runningDehumidifierZ7Z8RSteelBoxG12: "7b623ea1-440c-4bf1-9efd-156396257154",
        runningDehumidifierZ8B5LSteelBoxG16: "92affc45-73e1-4ba3-9434-3e564d0848ca",
        runningDehumidifierZ8B5RSteelBoxG15: "d7d77598-260c-483c-81d8-9454182dd77a",

        //malfunction
        malfunctionDehumidifierZ3TowerMid: "b76e3d1b-17b3-48a1-b5bf-54bba5ed67c1",
        malfunctionDehumidifierZ3B5LSteelBoxG1: "aa67031c-00ab-4dbe-8783-6a2ab43e3744",
        malfunctionDehumidifierZ4TowerMid: "4f36f298-0536-413a-b97e-62866346085f",
        malfunctionDehumidifierZ4TowerTop: "2feedca5-679b-43d5-beb3-1919dee9c69d",
        malfunctionDehumidifierZ5TowerMid: "fe4f9046-7fa1-4b81-9089-bb73909e37b6",
        malfunctionDehumidifierZ5TowerTop: "77c09a14-e132-49d2-b652-0617b7dd4631",
        malfunctionDehumidifierZ6TowerMid: "915f58db-c862-47b7-9c83-ed319f86d3a0",
        malfunctionDehumidifierZ6TowerTop: "a9ca5c3e-9bab-437c-a423-c07dd4496909",
        malfunctionDehumidifierZ7TowerMid: "7a324484-b71e-46c5-bf8f-f34a1ad40c75",
        malfunctionDehumidifierZ7TowerTop: "60758cfc-d499-4fe7-897e-acca0d659fcc",
        malfunctionDehumidifierZ8TowerMid: "GUID",
        malfunctionDehumidifierZ8TowerTop: "31d41712-dec8-4b4c-879d-547cd16750fb",

        malfunctionDehumidifierZ3B5LSteelBoxG1: "c65480ef-4c7d-4b4a-81dc-9b6ccf9a4f94",
        malfunctionDehumidifierZ3B5RSteelBoxG2: "6d8a1df6-575c-4624-b0f8-78033839720f",
        malfunctionDehumidifierZ4B11LSteelBoxG3: "30c31f46-8336-403d-a1ac-6dcee9c5f4b8",
        malfunctionDehumidifierZ4B11RSteelBoxG4: "9eebd884-8226-4424-a0b9-55e2e5f7341c",
        malfunctionDehumidifierZ4Z8RSteelBoxG5: "5d3786eb-6379-4730-85c9-53096f571b9e",
        malfunctionDehumidifierZ4Z8LSteelBoxG6: "211824c7-01e2-453d-8a44-74275323d8e4",
        malfunctionDehumidifierZ5Z1RSteelBoxG7: "5e34ccd8-27fe-4e57-bb87-c09761d390ed",
        malfunctionDehumidifierZ5Z1LSteelBoxG8: "5c6dfba3-3033-4826-98dd-e19543f5d57b",
        malfunctionDehumidifierZ6Z1LSteelBoxG9: "cd17a571-e9f0-4af5-b344-28f68547c111",
        malfunctionDehumidifierZ6Z1RSteelBoxG10: "4d9928dd-18db-4416-bcac-8b3466605088",
        malfunctionDehumidifierZ7Z8LSteelBoxG11: "3e3f42f4-a56a-4362-b13b-58a6ff04e86e",
        malfunctionDehumidifierZ7Z8RSteelBoxG12: "4e3bdde1-90e2-4db9-9ce7-30c88447ab72",
        malfunctionDehumidifierZ7B11RSteelBoxG13: "bf39be53-4f36-447a-9f08-aa49b5d9ff0e",
        malfunctionDehumidifierZ7B11LSteelBoxG14: "2da9b9a2-59e1-4f9f-9cab-3077e4cc7cdc",
        malfunctionDehumidifierZ8B5RSteelBoxG15: "d8140e40-f8a3-4e61-8ff8-df4f9c9ca625",
        malfunctionDehumidifierZ8B5LSteelBoxG16: "a2d0193e-f39f-499d-b97a-c748623c0c09",
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {},

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        currentADehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        currentADehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        currentADehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        currentADehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        currentADehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        currentADehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        currentADehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        currentADehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        currentADehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        currentADehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        currentADehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        currentADehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        currentADehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        currentADehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        currentADehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        currentADehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
        currentBDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        currentBDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        currentBDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        currentBDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        currentBDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        currentBDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        currentBDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        currentBDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        currentBDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        currentBDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        currentBDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        currentBDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        currentBDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        currentBDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        currentBDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        currentBDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
        currentCDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        currentCDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        currentCDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        currentCDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        currentCDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        currentCDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        currentCDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        currentCDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        currentCDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        currentCDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        currentCDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        currentCDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        currentCDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        currentCDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        currentCDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        currentCDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",

        voltageABDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        voltageABDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        voltageABDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        voltageABDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        voltageABDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        voltageABDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        voltageABDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        voltageABDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        voltageABDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        voltageABDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        voltageABDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        voltageABDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        voltageABDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        voltageABDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        voltageABDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        voltageABDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
        voltageBCDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        voltageBCDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        voltageBCDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        voltageBCDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        voltageBCDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        voltageBCDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        voltageBCDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        voltageBCDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        voltageBCDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        voltageBCDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        voltageBCDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        voltageBCDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        voltageBCDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        voltageBCDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        voltageBCDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        voltageBCDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
        voltageACDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        voltageACDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        voltageACDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        voltageACDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        voltageACDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        voltageACDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        voltageACDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        voltageACDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        voltageACDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        voltageACDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        voltageACDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        voltageACDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        voltageACDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        voltageACDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        voltageACDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        voltageACDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",

        powerActiveDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        powerActiveDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        powerActiveDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        powerActiveDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        powerActiveDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        powerActiveDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        powerActiveDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        powerActiveDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        powerActiveDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        powerActiveDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        powerActiveDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        powerActiveDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        powerActiveDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        powerActiveDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        powerActiveDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        powerActiveDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
        powerReactiveDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        powerReactiveDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        powerReactiveDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        powerReactiveDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        powerReactiveDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        powerReactiveDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        powerReactiveDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        powerReactiveDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        powerReactiveDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        powerReactiveDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        powerReactiveDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        powerReactiveDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        powerReactiveDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        powerReactiveDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        powerReactiveDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        powerReactiveDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
        powerApparentDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        powerApparentDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        powerApparentDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        powerApparentDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        powerApparentDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        powerApparentDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        powerApparentDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        powerApparentDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        powerApparentDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        powerApparentDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        powerApparentDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        powerApparentDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        powerApparentDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        powerApparentDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        powerApparentDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        powerApparentDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",

        energyActiveDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        energyActiveDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        energyActiveDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        energyActiveDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        energyActiveDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        energyActiveDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        energyActiveDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        energyActiveDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        energyActiveDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        energyActiveDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        energyActiveDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        energyActiveDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        energyActiveDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        energyActiveDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        energyActiveDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        energyActiveDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
        energyReactiveDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        energyReactiveDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        energyReactiveDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        energyReactiveDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        energyReactiveDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        energyReactiveDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        energyReactiveDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        energyReactiveDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        energyReactiveDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        energyReactiveDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        energyReactiveDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        energyReactiveDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        energyReactiveDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        energyReactiveDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        energyReactiveDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        energyReactiveDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",

        frequencyDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        frequencyDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        frequencyDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        frequencyDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        frequencyDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        frequencyDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        frequencyDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        frequencyDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        frequencyDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        frequencyDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        frequencyDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        frequencyDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        frequencyDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        frequencyDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        frequencyDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        frequencyDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {
        malfunctionDehumidifierZ3B5LSteelBoxG1: "errorZ3TowerTop",
        malfunctionDehumidifierZ3TowerMid: "errorZ3TowerMid",
        malfunctionDehumidifierZ4TowerTop: "errorZ4TowerTop",
        malfunctionDehumidifierZ4TowerMid: "errorZ4TowerMid",
        malfunctionDehumidifierZ5TowerTop: "errorZ5TowerTop",
        malfunctionDehumidifierZ5TowerMid: "errorZ5TowerMid",
        malfunctionDehumidifierZ6TowerTop: "errorZ6TowerTop",
        malfunctionDehumidifierZ6TowerMid: "errorZ6TowerMid",
        malfunctionDehumidifierZ7TowerTop: "errorZ7TowerTop",
        malfunctionDehumidifierZ7TowerMid: "errorZ7TowerMid",
        malfunctionDehumidifierZ8TowerTop: "errorZ8TowerTop",
        malfunctionDehumidifierZ8TowerMid: "errorZ8TowerMid",

        malfunctionDehumidifierZ3B5LSteelBoxG1: "errorZ3B5LSteelBoxG1",
        malfunctionDehumidifierZ3B5RSteelBoxG2: "errorZ3B5RSteelBoxG2",
        malfunctionDehumidifierZ4B11LSteelBoxG3: "errorZ4B11LSteelBoxG3",
        malfunctionDehumidifierZ4B11RSteelBoxG4: "errorZ4B11RSteelBoxG4",
        malfunctionDehumidifierZ4Z8RSteelBoxG5: "errorZ4Z8RSteelBoxG5",
        malfunctionDehumidifierZ4Z8LSteelBoxG6: "errorZ4Z8LSteelBoxG6",
        malfunctionDehumidifierZ5Z1RSteelBoxG7: "errorZ5Z1RSteelBoxG7",
        malfunctionDehumidifierZ5Z1LSteelBoxG8: "errorZ5Z1LSteelBoxG8",
        malfunctionDehumidifierZ6Z1LSteelBoxG9: "errorZ6Z1LSteelBoxG9",
        malfunctionDehumidifierZ6Z1RSteelBoxG10: "errorZ6Z1RSteelBoxG10",
        malfunctionDehumidifierZ7Z8LSteelBoxG11: "errorZ7Z8LSteelBoxG11",
        malfunctionDehumidifierZ7Z8RSteelBoxG12: "errorZ7Z8RSteelBoxG12",
        malfunctionDehumidifierZ7B11RSteelBoxG13: "errorZ7B11RSteelBoxG13",
        malfunctionDehumidifierZ7B11LSteelBoxG14: "errorZ7B11LSteelBoxG14",
        malfunctionDehumidifierZ8B5RSteelBoxG15: "errorZ8B5RSteelBoxG15",
        malfunctionDehumidifierZ8B5LSteelBoxG16: "errorZ8B5LSteelBoxG16",
      },

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {},

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierZ3B5LSteelBoxG1: "runningClassZ3TowerTop",
        runningDehumidifierZ3TowerMid: "runningClassZ3TowerMid",
        runningDehumidifierZ4TowerTop: "runningClassZ4TowerTop",
        runningDehumidifierZ4TowerMid: "runningClassZ4TowerMid",
        runningDehumidifierZ5TowerTop: "runningClassZ5TowerTop",
        runningDehumidifierZ5TowerMid: "runningClassZ5TowerMid",
        runningDehumidifierZ6TowerTop: "runningClassZ6TowerTop",
        runningDehumidifierZ6TowerMid: "runningClassZ6TowerMid",
        runningDehumidifierZ7TowerTop: "runningClassZ7TowerTop",
        runningDehumidifierZ7TowerMid: "runningClassZ7TowerMid",
        runningDehumidifierZ8TowerTop: "runningClassZ8TowerTop",
        runningDehumidifierZ8TowerMid: "runningClassZ8TowerMid",

        runningDehumidifierZ3B5LSteelBoxG1: "runningClassZ3B5LSteelBoxG1",
        runningDehumidifierZ3B5RSteelBoxG2: "runningClassZ3B5RSteelBoxG2",
        runningDehumidifierZ4B11LSteelBoxG3: "runningClassZ4B11LSteelBoxG3",
        runningDehumidifierZ4B11RSteelBoxG4: "runningClassZ4B11RSteelBoxG4",
        runningDehumidifierZ4Z8RSteelBoxG5: "runningClassZ4Z8RSteelBoxG5",
        runningDehumidifierZ4Z8LSteelBoxG6: "runningClassZ4Z8LSteelBoxG6",
        runningDehumidifierZ5Z1RSteelBoxG7: "runningClassZ5Z1RSteelBoxG7",
        runningDehumidifierZ5Z1LSteelBoxG8: "runningClassZ5Z1LSteelBoxG8",
        runningDehumidifierZ6Z1LSteelBoxG9: "runningClassZ6Z1LSteelBoxG9",
        runningDehumidifierZ6Z1RSteelBoxG10: "runningClassZ6Z1RSteelBoxG10",
        runningDehumidifierZ7Z8LSteelBoxG11: "runningClassZ7Z8LSteelBoxG11",
        runningDehumidifierZ7Z8RSteelBoxG12: "runningClassZ7Z8RSteelBoxG12",
        runningDehumidifierZ7B11RSteelBoxG13: "runningClassZ7B11RSteelBoxG13",
        runningDehumidifierZ7B11LSteelBoxG14: "runningClassZ7B11LSteelBoxG14",
        runningDehumidifierZ8B5RSteelBoxG15: "runningClassZ8B5RSteelBoxG15",
        runningDehumidifierZ8B5LSteelBoxG16: "runningClassZ8B5LSteelBoxG16",
      },

      //station id list
      stationIdList: [
        "09b52a1b-d484-4aed-8163-be877f07d7db",
        "a9967c5a-760c-412b-a857-658e1c9ba1a4",
        "81f565b9-9164-48b7-8ab5-2645a2fc82ab",
        "5be9917a-351a-4c38-974d-af67d130d819",
        "1b526494-699f-45d3-8d69-cbd09f579d11",
        "a09254f8-4017-42f6-b46f-41ef25e0e5ca",
        "6f2fcf9b-0529-4fec-b08b-d5f192290736",
        "008ea794-10f7-4f5e-8b51-b7c1b3d11d82",
        "9619a788-767b-4546-87e5-0e78dfe07969",
        "0c3d675d-13d7-42c9-b1d0-e68c17d324b7",
        "87cbc0f5-c415-45c0-89dc-9d92ba21d9ad",
        "8f8a0bf8-90ee-4cc8-b9e0-3de4ede98a59",
        "089d3309-fc18-4370-8314-fc57c9d48341",
        "cee91ca8-9ba8-4882-ab95-fd79f68a9ceb",
        "f9142fcc-3878-457d-936b-66511a93e950",
        "ed80ea74-3627-4cb2-9c27-b9099e874d0e",
      ],

      stationNameStationIdDict: {
        "stationG8": "09b52a1b-d484-4aed-8163-be877f07d7db",
        "stationG13": "a9967c5a-760c-412b-a857-658e1c9ba1a4",
        "stationG6": "81f565b9-9164-48b7-8ab5-2645a2fc82ab",
        "stationG16": "5be9917a-351a-4c38-974d-af67d130d819",
        "stationG7": "1b526494-699f-45d3-8d69-cbd09f579d11",
        "stationG2": "a09254f8-4017-42f6-b46f-41ef25e0e5ca",
        "stationG4": "6f2fcf9b-0529-4fec-b08b-d5f192290736",
        "stationG1": "008ea794-10f7-4f5e-8b51-b7c1b3d11d82",
        "stationG3": "9619a788-767b-4546-87e5-0e78dfe07969",
        "stationG5": "0c3d675d-13d7-42c9-b1d0-e68c17d324b7",
        "stationG12": "87cbc0f5-c415-45c0-89dc-9d92ba21d9ad",
        "stationG10": "8f8a0bf8-90ee-4cc8-b9e0-3de4ede98a59",
        "stationG15": "089d3309-fc18-4370-8314-fc57c9d48341",
        "stationG11": "cee91ca8-9ba8-4882-ab95-fd79f68a9ceb",
        "stationG9": "f9142fcc-3878-457d-936b-66511a93e950",
        "stationG14": "ed80ea74-3627-4cb2-9c27-b9099e874d0e",
      },

      stationNameLoadingDict: {
        "stationG8": false,
        "stationG13": false,
        "stationG6": false,
        "stationG16": false,
        "stationG7": false,
        "stationG2": false,
        "stationG4": false,
        "stationG1": false,
        "stationG3": false,
        "stationG5": false,
        "stationG12": false,
        "stationG10": false,
        "stationG15": false,
        "stationG11": false,
        "stationG9": false,
        "stationG14": false,
      }

    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      this.loading = true;
      // let stationRequestList = [];
      // this.stationIdList.forEach((stationId) => {
      //   stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      // });

      // this.$http.all(stationRequestList).then(
      //   this.$http.spread((...resList) => {
      //     resList.forEach((res) => {
      //       this.setDataAndError(res.data);
      //       this.loading = false;
      //     });
      //   })
      // );

      for (let stationName in this.stationNameLoadingDict) {
        this.stationNameLoadingDict[stationName] = true;
      }

      this.$nextTick(() => {
        for (let stationName in this.stationNameStationIdDict) {
          this.getDataForStation(stationName);
        }

        setTimeout(() => {
          this.loading = false;
        }, 500);

      })


    },
    getDataForStation(stationName) {
      let stationId = this.stationNameStationIdDict[stationName];
      if (!stationId) {
        return;
      }

      this.stationNameLoadingDict[stationName] = true;
      this.$http.get('/deviceData/Station?stationId=' + stationId).then((res) => {
        this.setDataAndError(res.data);
        this.stationNameLoadingDict[stationName] = false;
      })
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          console.log(dataName + ": " + this.dataNameErrorNameDict[dataName]);

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];

            if (errorName === "errorZ6Z1LSteelBoxG9") {
              console.log(errorName + ": " + this[errorName] + ", " + stationData[dataId].errorLevel);
            }

            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }

      // console.log("error g1: " + this.errorZ3B5LSteelBoxG1);
      // console.log("error g9: " + this.errorZ6Z1LSteelBoxG9);
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", 除湿机运行";
        } else if (runningFlag === 0) {
          result += ", 除湿机停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    assembleTooltip_simpleKeyValue(name, value, unit) {
      let result = "";
      if (name) {
        result += name + "\u00A0\u00A0\u00A0\u00A0";
      }

      if (value === "--" || value === null || value === undefined || isNaN(Number(value))) {
        result += "数据中断";
      } else {
        result += Number(value).toFixed(1);
        if (unit) {
          result += unit;
        }
      }

      return result;
    },

    assembleTooltip_groupKeyValue(name, keyList, valueList, unitList) {
      let result = "";
      if (name) {
        result += name + "\u00A0\u00A0\u00A0\u00A0";
      }

      for (let i = 0; i < keyList.length; i++) {
        let key = keyList[i];
        let value = valueList[i];
        let unit = unitList[i];

        if (i !== 0) {
          result += " ";
        }
        result += key + ": ";

        if (value === "--" || value === null || value === undefined || isNaN(Number(value))) {
          result += "数据中断";
        } else {
          result += Number(value).toFixed(1);
          if (unit) {
            result += unit;
          }
        }
      }

      return result;
    },
    // hrefToScenario(id) {
    //   if (!id || id === "") {
    //     return;
    //   }

    //   this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    // },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }

  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}

@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }

  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: bold;
        font-size: 32px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .sensor1:after {
          background: #c7798b;
        }

        .sensor2:after {
          background: #3376c7;
        }
      }

      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;

        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;

          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }

        .default:after {
          background: #ffff00;
        }

        .running:after {
          background: #67dd34;
        }

        .stopped:after {
          background: #a0a0a0;
        }
      }

      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }

        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;

        i {
          font-size: 30px;
        }

        .dir-text {
          font-size: 20px;
        }
      }

      .left-dir {
        left: 185px;
      }

      .right-dir {
        flex-direction: row-reverse;
        right: 185px;
      }

      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/jiashao/bridgeLine2.png");
        background-position-y: 100%;

        &.image-reversed {
          background-image: url("../../assets/image/jiashao/bridgeLineReversed2.png");
        }

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .tower-name {
          border-radius: 50%;
          color: #344084;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 3px solid;
          width: 24px;
          height: 24px;
          padding-left: 1px;

          &.tower-name-z3 {
            position: absolute;
            top: 232px;
            left: 264px;
          }

          &.tower-name-z4 {
            position: absolute;
            top: 234px;
            left: 620px;
          }

          &.tower-name-z5 {
            position: absolute;
            top: 234px;
            left: 975px;
          }

          &.tower-name-z6 {
            position: absolute;
            top: 234px;
            left: 184px;
          }

          &.tower-name-z7 {
            position: absolute;
            top: 234px;
            left: 540px;
          }

          &.tower-name-z8 {
            position: absolute;
            top: 232px;
            left: 895px;
          }
        }

        .stati {
          position: absolute;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);

            &:before {
              background-color: #ed6a5a;
            }

            &>p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 96%;
              transform: translate(0%, 0%);
            }

            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }

            &.bottom-pos-sta:before {
              left: 50%;
              top: 95%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .bold {
              font-weight: 800;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }

              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;

          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }

          &:before {
            width: 50px;
          }

          &:after {
            width: 15px;
          }

          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);

            &>p {
              margin: 0;
              white-space: nowrap;

              &:first-child {
                font-size: 13px;
              }
            }

            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }

            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }

            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }

            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }

          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }

          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }

          &.sensor1 {
            background: #c7798b;

            &:after,
            &:before {
              background: #c7798b;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #c7798b;
              }
            }
          }

          &.sensor2 {
            background: #3376c7;

            &:after,
            &:before {
              background: #3376c7;
            }

            .state-info {
              background-color: rgba(246, 250, 255, 0.9);

              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .station-block-g1g2 {
          top: 162px;
          left: 185px;
        }

        .station-block-g3g4 {
          top: 162px;
          left: 470px;
        }

        .station-block-g5g6 {
          top: 162px;
          left: 745px;
        }

        .station-block-g7g8 {
          top: 162px;
          left: 1012px;
        }

        .station-block-g9g10 {
          top: 162px;
          left: 155px;
        }

        .station-block-g11g12 {
          top: 162px;
          left: 430px;
        }

        .station-block-g13g14 {
          top: 162px;
          left: 700px;
        }

        .station-block-g15g16 {
          top: 162px;
          left: 980px;
        }

        .sta-g1 {
          top: 186px;
          left: 70px;

          &::before {
            bottom: 42px;
            left: 79px;
            width: 80px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 80px;
            left: 79px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g2 {
          top: 186px;
          left: 68px;

          &::before {
            bottom: -25px;
            left: 86px;
            width: 65px;
            transform: rotate(285deg);
          }

          &::after {
            bottom: -56px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g3 {
          top: 186px;
          left: 355px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -220px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g4 {
          top: 186px;
          left: 355px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -223px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g5 {
          top: 186px;
          left: 630px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -220px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g6 {
          top: 186px;
          left: 630px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -220px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g7 {
          top: 186px;
          left: 897px;

          &::before {
            bottom: 42px;
            left: 95px;
            width: 80px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 80px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -370px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g8 {
          top: 186px;
          left: 897px;

          &::before {
            bottom: -25px;
            left: 102px;
            width: 65px;
            transform: rotate(255deg);
          }

          &::after {
            bottom: -56px;
            left: 143px;
            width: 30px;
          }

          .state-info {
            right: -370px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g9 {
          top: 186px;
          left: 40px;

          &::before {
            bottom: 42px;
            left: 79px;
            width: 80px;
            transform: rotate(75deg);
          }

          &::after {
            bottom: 80px;
            left: 79px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g10 {
          top: 186px;
          left: 38px;

          &::before {
            bottom: -25px;
            left: 86px;
            width: 65px;
            transform: rotate(285deg);
          }

          &::after {
            bottom: -56px;
            left: 81px;
            width: 30px;
          }

          .state-info {
            right: -85px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g11 {
          top: 186px;
          left: 315px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -220px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g12 {
          top: 186px;
          left: 315px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -220px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g13 {
          top: 186px;
          left: 585px;

          &::before {
            bottom: 34px;
            left: 97px;
            width: 60px;
            transform: rotate(90deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -223px;
            top: -100px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g14 {
          top: 186px;
          left: 585px;

          &::before {
            bottom: 0px;
            left: 117px;
            width: 20px;
            transform: rotate(270deg);
          }

          &::after {
            bottom: 62px;
            left: 81px;
            width: 0px;
          }

          .state-info {
            right: -220px;
            top: 65px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g15 {
          top: 186px;
          left: 864px;

          &::before {
            bottom: 42px;
            left: 95px;
            width: 80px;
            transform: rotate(105deg);
          }

          &::after {
            bottom: 80px;
            left: 145px;
            width: 30px;
          }

          .state-info {
            right: -370px;
            top: -80px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }

        .sta-g16 {
          top: 186px;
          left: 864px;

          &::before {
            bottom: -25px;
            left: 102px;
            width: 65px;
            transform: rotate(255deg);
          }

          &::after {
            bottom: -56px;
            left: 143px;
            width: 30px;
          }

          .state-info {
            right: -370px;
            top: 55px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 195px;
          }
        }
      }
    }
  }
}
</style>